import { Component, OnInit, ViewChild, ElementRef, QueryList, ViewChildren, OnDestroy } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TimesheetsService } from '../Timesheet.service';
import { CaptureTime, Statusdata, WeeklyDetail, Staffdata, CaptureLogComment } from '../../Models/Timesheet';
import { DatePipe } from '@angular/common';
import { FormBuilder, Validators, FormGroup, FormControl } from '@angular/forms';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { Observable, Subscription, Subject } from "rxjs";
import { map, startWith, takeUntil } from "rxjs/operators";
import { ActivatedRoute } from '@angular/router';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { JobMilestoneService } from 'src/app/job/job.service';
import { LogTimeService } from 'src/app/shared/logtime.service';
import { UserManagementService } from '../../shared/userManagement.service';
import { selectAllUsers } from 'src/app/store/users/users.selectors';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-timesheet',
  templateUrl: './timesheet.component.html',
  styleUrls: ['./timesheet.component.scss']
})

export class TimesheetComponent implements OnInit, OnDestroy {
  @ViewChild('addRowScroll') private newRowScrollContainer: ElementRef;
  @ViewChild('WarningPopup', { static: false }) public WarningPopup: ModalDirective;
  @ViewChild('monInput') public monInput: ElementRef;
  @ViewChild('createjobModalPopup', { static: false }) public createjobModalPopup: any; //ModalDirective
  @ViewChildren('autocomplete') autocomplete: QueryList<any>;
  public weeklyList: WeeklyDetail[] = [];
  dateCustomClasses: DatepickerDateCustomClasses[];
  Activities: any = []; public timespentField: any;
  contexttype: any = []; _lastjobId: any = 0; _lastcontextId: any = 0;
  public IsMytimesheet: boolean = true; public IsUserSelected: boolean = false; public selectedUser: string = ''; public selectedUname: string = 'My Timesheet';
  public _wdata = new WeeklyDetail(); public _comment = new CaptureLogComment(); public captureTime = new CaptureTime(); public listcaptureTime: Array<CaptureTime> = [];
  headerDay1: any;
  headerDay2: any;
  headerDay3: any;
  headerDay4: any;
  headerDay5: any;
  headerDay6: any;
  headerDay7: any;
  headerDayTotal: any;
  nonbillable: number;
  total: number;
  billable: number;
  nonbillabletimeVal: any;
  totaltimeVal: any;
  billabletimeVal: any;
  billableminutes: any;
  billablehours: any;
  nonbillablehours: any;
  nonbillableminutes: any;
  totalhours: any;
  totalminutes: any;
  percentagetotal: number;
  percentagenonbillable: number;
  movieForm: FormGroup;
  private sub = new Subscription();
  isDirty = false;
  filterm: any;
  percentagebillable: number; ct_origin: string; flagIsJob: boolean = true; _currentjobStatusId: number = 0;
  addcommentbuttonshow: boolean = false; dynamicArray: Array<WeeklyDetail> = []; tempdynamicArray: Array<WeeklyDetail> = []; newDynamic: any = {};
  keyword = 'name';
  mkeyword = 'statusName'; dynamicMilestone: any; dynamicName: any;
  lstdata: any = []; commentdata: any = []; lstMilestonedata: Array<Statusdata> = []; public totalday1: number = 0;
  data = []; public _lststaff: Array<Staffdata> = [];
  model: any = {};
  public IsmonHighlighter: any = false; public IstueHighlighter: any = false; public IswedHighlighter: any = false;
  public IsthursHighlighter: any = false; public IsfriHighlighter: any = false;
  public IssatHighlighter: any = false; public IssunHighlighter: any = false;
  public IsmonHolidayHighlighter: any = ''; public IstueHolidayHighlighter: any = ''; public IswedHolidayHighlighter: any = '';
  public IsthursHolidayHighlighter: any = ''; public IsfriHolidayHighlighter: any = '';
  public IssatHolidayHighlighter: any = ''; public IssunHolidayHighlighter: any = '';
  public IsMonCheckDate: boolean = false;
  public IstueCheckDate: boolean = false;
  public IswedCheckDate: boolean = false;
  public IsthursCheckDate: boolean = false;
  public IsfriCheckDate: boolean = false;
  public IssatCheckDate: boolean = false;
  public IssunCheckDate: boolean = false;
  public isAddJob: number = 0;
  numberOfHours: number; public selectedItemsDays = [];
  datatoslider: string; _currentStatus: string = '';
  datePickerValue: Date = new Date(2020, 7);
  Friday: any;
  Thruds: any;
  mon: any; mon1: any;
  Tuesday: any;
  Wednedday: any;
  Sat: any;
  Sun: any;
  ct_startdate: any;
  ct_enddate: any;
  timepickerVisible = false;
  mytime: Date;
  w1: Date;
  w2: Date;
  w3: Date;
  w4: Date;
  w5: Date;
  w6: Date;
  w7: Date;
  checktimesheetpopup: boolean = false;
  minDate: Date;
  lastDate: Date;
  tempstdate: Date;
  tempenddate: Date;
  fromdate: any;
  todate: any;
  tempFromDate: any;
  tempTodate: any;
  netmon: string;
  nextsun: string;
  premon: string;
  presun: string;
  nexttues: any
  nextwed: any
  nextthrus: any
  nextfri: any
  nextsat: any
  pretues: any
  prewed: any
  prethrus: any
  prefri: any
  presat: any
  addtimesheet: boolean = false;
  count = 0;
  selectedDate: any;
  displayDay1: string;
  displayMon: string;
  displayTue: string;
  displayWed: string;
  displayThr: string;
  displayFri: string;
  displaySat: string;
  displaySun: string;
  tUserid: string;
  timeCapturedforCell: boolean;
  public headers: any;
  checkDeleteday: boolean = false;
  istimesheetStaffshow: boolean = false; IsShowWeeks: boolean = false;
  public IsHiderightBox: boolean = false;
  cities: Array<ICity> = [];
  selectedItems: Array<ICity> = [];
  dropdownSettings: IDropdownSettings = {};
  headerIndex: any;
  activeState = 'Draft';
  usersdata: any;
  dtime: any;
  dat: any;
  commentjobid: any;
  myControl = new FormControl();
  options: User[] = [
    { name: "Mary here and sample code in the sentece", value: "1" },
    { name: "Shelle there", value: "2" },
    { name: "Igor where", value: "3" }
  ];
  filteredOptions: Observable<User[]>;
  users: any[];
  addcssclass: string;
  thiscompart: string;
  public IsDisablestatusChange: boolean = true;
  tempJobid: number;
  tempClientid: number;
  Contactpage: string;
  unsubscribe = new Subject<void>();
  users$ = this.store.select(selectAllUsers);
  public bsModalRef: BsModalRef;

  constructor(private fb: FormBuilder, private _toastr: ToastrService, private _timesheetService: TimesheetsService, public datepipe: DatePipe, private route: ActivatedRoute, private modalService: BsModalService, private jobService: JobMilestoneService,private logtimeService: LogTimeService, private userManagementService: UserManagementService,private store: Store) {}

  ngOnInit() {
    this.movieForm = this.fb.group({
      name: ['', Validators.required],
      year: ['', Validators.required],
      image: ['', Validators.required]
    });

    this.sub.add(this.movieForm.valueChanges.subscribe( e => this.isDirty = true ));
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(""),
      map(value => (typeof value === "string" ? value : value.name)),
      map(name => (name ? this._filter(name) : this.options.slice()))
    );    
    localStorage.setItem("addtimesheetnotify", "false");
    localStorage.setItem("addtimesheetprof", "false");
    localStorage.setItem("addtimesheetindiv", "false");
    localStorage.setItem("addtimesheetchangepw", "false");
    this.getStaffs();
    this.tUserid = localStorage.getItem('Userid');
    this.model.startdate = new Date();   
    this.searchdata();
    this.GetTimeSheetBillableDetailsList();
    this.getTimeSheetDetailsList();
    this.getWeeklyTimeSheetDetailsList();
    const curr = new Date;
    const startDate = new Date(curr.setDate(curr.getDate() - curr.getDay()));
    const endDate = new Date(curr.setDate(curr.getDate() - curr.getDay() + 6))
    this.checkdates(startDate, endDate);
    this.onGetManagerAssignStaff();  
    this.selectedItems = [
      { item_id: 4, item_text: "Pune", item_di: true },
      { item_id: 6, item_text: "Navsari", item_di: true }
    ];
    this.dropdownSettings = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Entire week",
      unSelectAllText: "Entire week",
      itemsShowLimit: 1,
      disabledField:"item_di",
    };
  }
  canDeactivate() {
    return this.isDirty;
  }

  ngAfterViewInit() {
    const Type = this.route.snapshot.queryParams["Id"];
    if (Type != undefined && Type != null && Type != "" && Type != "undefined") {
      this.logtimeService.GetJobDetails(Type).pipe(takeUntil(this.unsubscribe)).subscribe(result => {
        if (result) {
          this.dat = result.commentDate;
          const dt = result.commentDate.split("-");
          const x = dt[2].split("T");
          this.dtime = new Date(dt[0], Number(dt[1]) - 1, x[0]);
          const dtime2 = new Date(dt[0], Number(dt[1]) - 1, x[0]);
          this.commentjobid = result.contextId;
          this.captureTime.startDate = this.dtime;
          this.model.sdate = this.dtime;
          this.model.startdate = this.dtime;
          this.searchdata();

          setTimeout(() => {
            const dt2 = this.datepipe.transform(dtime2, 'dd/MM/yyyy');
            this.GetLogCommentDetails(Type);
            this.getTimeSheetCommentByContext(result.contextId, "JobId", dt2);
            this.focusFunction("JobId", result.contextId, result.itemName, dtime2);
          }, 5000);
        }
      });
    }
  }

  addJobsPopup() {
    this.isAddJob = 1;
    this.Contactpage = "timeSheetPage";
    this.tempJobid = 0;
    this.bsModalRef = this.modalService.show(this.createjobModalPopup, {class: 'modal-lg modal-dialog-centered cmn-modal-dsgn m-auto', backdrop: 'static'})
  }

  closeCreateEditJobsPopUp() {
    this.getTimeSheetDetailsList();
    this.autocomplete.forEach(autocomplete => autocomplete.clear());
    this.tempJobid = 0;
    this.tempClientid = 0;
    this.bsModalRef?.hide();
  }

  scrollToElement(): void {
    this.newRowScrollContainer.nativeElement.scrollTop = this.newRowScrollContainer.nativeElement.scrollHeight;
  }

  displayFn(user?: User): string | undefined {
    return user ? user.name : undefined;
  }

  returnFn(user?: User): string | undefined {
    return user ? user.value : undefined;
  }

  getStaffs() {
    let _lst = [];
    let _lst2 = [];
    this.users$.subscribe(users => {
      if (users) {
        users.forEach(childObj => {
          let fname = childObj.firstName + ' ' + childObj.lastName;
          _lst.push({ firstName: fname, userId: childObj.userId });
          let firstname = '';  let lastname = '';
          if (childObj.firstName != null) {
            firstname = childObj.firstName.replace(/\s/g, "");
          }
          if (childObj.lastName != null) {
            lastname = childObj.lastName.replace(/\s/g, "");
            }
          let name = firstname + lastname;
          _lst2.push({ firstName: name, userId: childObj.userId });
        });
        _lst.push({ firstName: "Unassigned", userId: 'a8d31b07-71be-4034-970f-ae5348e264cd' });
        this.users = _lst;
        this.usersdata = _lst2;
      }
    });
  }

  private _filter(name: string): User[] {
    const filterValue = name.toLowerCase();

    return this.options.filter(
      option => option.name.toLowerCase().indexOf(filterValue) === 0
    );
  }

  onItemSelect(item: any) {}
  onItemDeSelect(item: any) {}
  onSelectAll(items: any) {}

  checkdates(startDate,endDate) { // Dev:Ramya; CUST-1792; 16Nov2022
    const currentDate = new Date();        
    const currentDay = this.datepipe.transform(currentDate, 'EEEE');
    if (currentDate < startDate && currentDate < endDate) {
      this.cities = [
        { item_id: 1, item_text: "Monday", item_di: true },
        { item_id: 2, item_text: "Tuesday", item_di: true },
        { item_id: 3, item_text: "Wednesday", item_di: true },
        { item_id: 4, item_text: "Thursday", item_di: true },
        { item_id: 5, item_text: "Friday", item_di: true }

      ];
    } else if (currentDate > startDate && currentDate > endDate) {
      this.cities = [
        { item_id: 1, item_text: "Monday", item_di: false },
        { item_id: 2, item_text: "Tuesday", item_di: false },
        { item_id: 3, item_text: "Wednesday", item_di: false },
        { item_id: 4, item_text: "Thursday", item_di: false },
        { item_id: 5, item_text: "Friday", item_di: false }

      ];      
    } else if (currentDate >= startDate && currentDate <= endDate) {
      
    if (!(currentDay === "Saturday" || currentDay === "Sunday")) {
      switch (currentDay) {
        case "Monday":
          this.cities = [
            { item_id: 1, item_text: "Monday", item_di: false },
            { item_id: 2, item_text: "Tuesday", item_di: true },
            { item_id: 3, item_text: "Wednesday", item_di: true },
            { item_id: 4, item_text: "Thursday", item_di: true },
            { item_id: 5, item_text: "Friday", item_di: true }

          ];
          break;
        case "Tuesday":
          this.cities = [
            { item_id: 1, item_text: "Monday", item_di: false },
            { item_id: 2, item_text: "Tuesday", item_di: false },
            { item_id: 3, item_text: "Wednesday", item_di: true },
            { item_id: 4, item_text: "Thursday", item_di: true },
            { item_id: 5, item_text: "Friday", item_di: true }

          ];
          break;
        case "Wednesday":
          this.cities = [
            { item_id: 1, item_text: "Monday", item_di: false },
            { item_id: 2, item_text: "Tuesday", item_di: false },
            { item_id: 3, item_text: "Wednesday", item_di: false },
            { item_id: 4, item_text: "Thursday", item_di: true },
            { item_id: 5, item_text: "Friday", item_di: true }

          ];
          break;
        case "Thursday":
          this.cities = [
            { item_id: 1, item_text: "Monday", item_di: false },
            { item_id: 2, item_text: "Tuesday", item_di: false },
            { item_id: 3, item_text: "Wednesday", item_di: false },
            { item_id: 4, item_text: "Thursday", item_di: false },
            { item_id: 5, item_text: "Friday", item_di: true }

          ];
          break;
        case "Friday":
          this.cities = [
            { item_id: 1, item_text: "Monday", item_di: false },
            { item_id: 2, item_text: "Tuesday", item_di: false },
            { item_id: 3, item_text: "Wednesday", item_di: false },
            { item_id: 4, item_text: "Thursday", item_di: false },
            { item_id: 5, item_text: "Friday", item_di: false }

          ];
          break;
      }
    }
    }
    function addDays(date, days) {
      const copy = new Date(Number(date))
      copy.setDate(date.getDate() + days)
      return copy

    }
  }

  saveTimelogFunction(data) {
    if (this._comment.context == "JobId") {
      this.captureTime.jobId = this._comment.contextId;
      this.flagIsJob = true;
      this.ct_origin = 'job';
      this._lastjobId = this._comment.contextId;
    }
    else if (this._comment.context == "MastertimesheetId") {
      this.ct_origin = 'msid';
      this.captureTime.mastertimesheetId = this._comment.contextId;
      this.flagIsJob = false;
    }
    else if (this._comment.context == "MasterHolidayId") {
      this.ct_origin = 'mhid';
      this.captureTime.masterholidayId = this._comment.contextId;
      this.flagIsJob = false;
    }
    this.captureTime.endDate = this.captureTime.startDate = this._comment.commentDate;
    this.captureTime.isBillable = true;
    this.captureTime.loggedTime = Number(data[0].cellvalue);
    this.captureTime.startTime = 2;
    this.captureTime.endTime = 5;

    this.captureTime.description = JSON.stringify(data);
    if (this.captureTime.loggedTime == '') { this.captureTime.loggedTime = 0; }
    this.captureTime.taskId = 0
    if (this.ct_origin == 'job') { this.captureTime.mastertimesheetId = this.captureTime.masterholidayId = this.captureTime.clientId = this.captureTime.entityId = 0; this.captureTime.isBillable = true; }
    else if (this.ct_origin == 'msid') { this.captureTime.jobId = this.captureTime.masterholidayId = this.captureTime.entityId = this.captureTime.clientId = 0; this.captureTime.isBillable = false; }
    else if (this.ct_origin == 'mhid') { this.captureTime.jobId = this.captureTime.mastertimesheetId = this.captureTime.entityId = this.captureTime.clientId = 0; this.captureTime.isBillable = false; }
    if (this.captureTime.taskId = undefined) { this.captureTime.taskId = 0 }

    if (this.captureTime.endDate == '' || this.captureTime.endDate == undefined) { this.captureTime.endDate = this.captureTime.startDate = new Date(); }
    this.captureTime.strtdate = data[0].startdate;
    this.captureTime.taskList = '';
    this.logtimeService.PostTimeForWeek(this.captureTime).pipe(takeUntil(this.unsubscribe)).subscribe(result => {
        if (result.status) {
          this._toastr.success('successfully captured log time', 'Timesheet');
          this.timeCapturedforCell = false;
          this.setStateAsActive(''); this.setMyStatesAsActive(this.tUserid, false, 'My Timesheet')
        }
        else if (result.message == "EXISTS") {
          this._toastr.error('Final Invoice is exists for this job', 'Timesheet');
        }
        else if (result.message == "HolidayLeave") { }
        else {
          alert(result.message);
        }
        this.selectedItemsDays = null;
      }, error => { this._toastr.error(error.message, 'Timesheet') });
  }

  onDropDownClose() {
    if (this.dynamicArray.length == 0) { this.selectedItemsDays = null; return; }
    let selectedCat = [];
    selectedCat = (this.selectedItemsDays != null && this.selectedItemsDays.length > 0) ?
      (this.selectedItemsDays.map(({ item_id }) => { return { item_id: item_id } })) : null;
    // Developer : Sachin yadav ; CUST-1161; Date: 05-May-2022
    if (selectedCat != null && selectedCat.length > 0) {
      selectedCat.forEach(childObj => {
        let i = this._tempindex;   // Sasmit, 24-Aug-2022, Excel-issue time added to other jobs 
        if (childObj.item_id == 1 && (!this.IsMonDayisGreater || this._comment.context != "JobId")) { // Developer: Ramya; Ticket: CUST-1275; Date:07-June-2022
          this._tcurrentvalue = this.dynamicArray[i].day1 == null || this.dynamicArray[i].day1 == '' ? '' : this.dynamicArray[i].day1 ;
          this.onChangeCalculate(this.timespentField, this.dynamicArray[i].context, this.dynamicArray[i].contextId, this.w1, this.w7, 1, i);
        }
        if (childObj.item_id == 2 && (!this.IsTueDayisGreater || this._comment.context != "JobId")) {
          this._tcurrentvalue = this.dynamicArray[i].day2 == null || this.dynamicArray[i].day2 == '' ? '' : this.dynamicArray[i].day2;
          this.onChangeCalculate(this.timespentField, this.dynamicArray[i].context, this.dynamicArray[i].contextId, this.w2, this.w7, 2, i);
        }
        if (childObj.item_id == 3 && (!this.IsWedDayisGreater || this._comment.context != "JobId")) {
          this._tcurrentvalue = this.dynamicArray[i].day3 == null || this.dynamicArray[i].day3 == '' ? '' : this.dynamicArray[i].day3;
          this.onChangeCalculate(this.timespentField, this.dynamicArray[i].context, this.dynamicArray[i].contextId, this.w3, this.w7, 3, i);
        }
        if (childObj.item_id == 4 && (!this.IsThursDayisGreater|| this._comment.context != "JobId")) {
          this._tcurrentvalue = this.dynamicArray[i].day4 == null || this.dynamicArray[i].day4 == '' ? '' : this.dynamicArray[i].day4;
          this.onChangeCalculate(this.timespentField, this.dynamicArray[i].context, this.dynamicArray[i].contextId, this.w4, this.w7, 4, i);
        }
        if (childObj.item_id == 5 && (!this.IsFriDayisGreater || this._comment.context != "JobId")) {
          this._tcurrentvalue = this.dynamicArray[i].day5 == null || this.dynamicArray[i].day5 == '' ? '' : this.dynamicArray[i].day5;
          this.onChangeCalculate(this.timespentField, this.dynamicArray[i].context, this.dynamicArray[i].contextId, this.w5, this.w7, 5, i);
        }
      });
      if (this.strlogtimedetail.length > 0) {      
      }
    }
  }

  states = [
    'Agnes Isobelle', 'Ellis Lola',
    'Marie Anica',
    'Bethany Racheal',
    'Declan saif', 'Oscar Dany', 'Rapheal Wayne', 'Anika Tobias'
  ]

  public _tcurrentvalue: any = '0';
  onsetdefaultValue(item, i, tempI) {
    if (item != undefined) {
      if (item.context != 'JobId') {
        this._currentStatus = '';
      }      
      this._tempcellHeaeder = i; this._tempindex = tempI;
      this.setFinalInvoiceflag(item.isFinalInvoice);
      if (i == 1) { this.timespentField = item.day1; this._tcurrentvalue = item.day1; }
      else if (i == 2) { this.timespentField = item.day2; this._tcurrentvalue = item.day2; }
      else if (i == 3) { this.timespentField = item.day3; this._tcurrentvalue = item.day3; }
      else if (i == 4) { this.timespentField = item.day4; this._tcurrentvalue = item.day4; }
      else if (i == 5) { this.timespentField = item.day5; this._tcurrentvalue = item.day5; }
      else if (i == 6) { this.timespentField = item.day6; this._tcurrentvalue = item.day6; }
      else if (i == 7) { this.timespentField = item.day7; this._tcurrentvalue = item.day7; }
      else { this.timespentField = ''; this._tcurrentvalue = ''; }
    }
  }

  public isfinalInvoice: boolean = false;
  setFinalInvoiceflag(flag) {
    this.isfinalInvoice = flag;
  }

  setStateAsActive(state) {
    this.activeState = state;
  }

  selectEventSingle1(item) {
    this.focusFunction(item.contextName, item.contextId, item.name, new Date());
    this.setFinalInvoiceflag(item.isFinalInvoice);
  }

  UpdateWeekStauts(event) { this.IsShowWeeks = event.checked; }

  selectEventSingle(item) {
    this._comment.mileStoneId = item.statusId; this.onSubmitStatusChange();
  }

  focusFunction(_context, _contextId, name, selecteddate) {
    this._Isfortimespent = false;
    this.IsselectStatuschk = false; this.dynamicMilestone = '';
    this.selectedDate = this.datepipe.transform(selecteddate, 'EE MMM d');
    if (_context == "JobId") {
      this._lastjobId = _contextId; this.getMileStoneList(this._lastjobId, selecteddate);
      this.ct_origin = 'job';
      this._lastjobId = _contextId;
      this.IsDisablestatusChange = false;
    }
    else if (_context == "MastertimesheetId") {
      this._currentStatus = ''; this.ct_origin = 'msid'; this.getTimeSheetComment(_contextId, _context, selecteddate);
      this.IsDisablestatusChange = true;
    }
    else if (_context == "MasterHolidayId") {
      this._currentStatus = ''; this.ct_origin = 'mhid'; this.getTimeSheetComment(_contextId, _context, selecteddate);
      this.IsDisablestatusChange = true;
    }
    this.flagIsJob = _contextId == 0 || _context == "MastertimesheetId" || _context == "MasterHolidayId" ? false : true;
    this.dynamicName = name; this.onClearComment();
    this._comment.context = _context;
    this._comment.contextId = _contextId;
    this._comment.itemName = name;
    this._comment.commentDate = selecteddate; this._lastcontextId = _contextId; this._comment.comment = '';
    // this.getTimeSheetComment(_contextId, _context, selecteddate);
  }

  onClearComment() {
    this.dynamicMilestone = '';
    this._comment = new CaptureLogComment();
  }

  public isTabButtonClick: boolean = false;
  onKey(event) {
    const charCode = (event.which) ? event.which : event.keyCode;
    this.isTabButtonClick = charCode == 9 ? true : false;// Here read the active selected link.
  } 

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode == 46 || (charCode > 47 && charCode < 59)) {
      return true;
    } else { return false; }
  }

  public _tempcellHeaeder: any = 0; public _tempindex: any = 0; public _Isfortimespent: boolean = false;
  onChangeTimeSpent() {
    if (this.dynamicArray.length > 0) {
      this.onChangeCalculate(this.timespentField, this._comment.context, this._comment.contextId,
        this._comment.commentDate, this.w7, this._tempcellHeaeder, this._tempindex); this.timeCapturedforCell = false;
          
      if (this.dynamicArray.length > 0) {       // Developer : Sachin yadav ; CUST-1161; Date: 05-May-2022
        this.onsetdefaultValue(this.dynamicArray[this._tempindex], this._tempcellHeaeder, this._tempindex);
      }
    }   
  }

  clickTimecell() { // Dev:Ramya; CUST-1845; 25Nov2022
    this.IsHiderightBox = true;
    this.selectedItemsDays = [];
  }

  oncalcaluteTime(val: string | number): string {
    const decimalTime = Number(val) * 3600;           // convert hours (decimal) to seconds
    const hours = Math.floor(decimalTime / 3600);
    const minutes = Math.floor((decimalTime % 3600) / 60);

    const hoursStr = hours < 10 ? `0${hours}` : `${hours}`;
    const minutesStr = minutes < 10 ? `0${minutes}` : `${minutes}`;

    return `${hoursStr}:${minutesStr}`;
  }

  resetCellValue(cellHeaeder, i, tval) {
    if (cellHeaeder == 1) {
      this.dynamicArray[i].day1 = tval;
    } if (cellHeaeder == 2) {
      this.dynamicArray[i].day2 = tval;
    } if (cellHeaeder == 3) {
      this.dynamicArray[i].day3 = tval;
    } if (cellHeaeder == 4) {
      this.dynamicArray[i].day4 = tval;
    } if (cellHeaeder == 5) {
      this.dynamicArray[i].day5 = tval;
    } if (cellHeaeder == 6) {
      this.dynamicArray[i].day6 = tval;
    } if (cellHeaeder == 7) {
      this.dynamicArray[i].day7 = tval;
    }
  }

  onChangeCalculate(cellvalue, _context, _contextId, _cday, _lday, cellHeaeder, i) {    
    localStorage.setItem("addtimesheetnotify", "true");
    localStorage.setItem("addtimesheetprof", "true");
    localStorage.setItem("addtimesheetindiv", "true");
    localStorage.setItem("addtimesheetchangepw", "true");
    this.headerIndex = i;
    if (_contextId == 0) {
      if (cellHeaeder == 1) {
        this.dynamicArray[i].day1 = '';
      } if (cellHeaeder == 2) {
        this.dynamicArray[i].day2 = '';
      } if (cellHeaeder == 3) {
        this.dynamicArray[i].day3 = '';
      } if (cellHeaeder == 4) {
        this.dynamicArray[i].day4 = '';
      } if (cellHeaeder == 5) {
        this.dynamicArray[i].day5 = '';
      } if (cellHeaeder == 6) {
        this.dynamicArray[i].day6 = '';
      } if (cellHeaeder == 7) {
        this.dynamicArray[i].day7 = '';
      } this._toastr.error("Please select an item to add a time log", 'Timesheet');
      return;
    }
    else {
      let _temptime: any;
      if (cellvalue.indexOf('.') > -1) {
        const pcheck = this.oncalcaluteTime(cellvalue);
        _temptime = Number(pcheck.replace(":", "."));

      } else {
        _temptime = this.numberToTimeCalculate(Number(cellvalue.replace(":", ".")));
      }
      let _val: boolean = false; _val = this.onhoursCheck(_temptime, cellHeaeder);
      if (!_val) {
        this.timespentField = this._tcurrentvalue; this.resetCellValue(cellHeaeder, i, this._tcurrentvalue); this._toastr.error('Cannot log more than 24h for a day', 'Timesheet'); return;
      }

      if (_temptime < 24) {
        if (_context == "JobId") {
          this.captureTime.jobId = _contextId;
          this.flagIsJob = true;
          this.ct_origin = 'job';
          this._lastjobId = _contextId;
        }
        else if (_context == "MastertimesheetId") {
          this.ct_origin = 'msid'
          this.captureTime.mastertimesheetId = _contextId
          this.flagIsJob = false;
        }
        else if (_context == "MasterHolidayId") {
          this.ct_origin = 'mhid'
          this.captureTime.masterholidayId = _contextId
          this.flagIsJob = false;
        }
        this.captureTime.endDate = this.captureTime.startDate = _cday;
        this.captureTime.isBillable = true;
        this.captureTime.loggedTime = Number(_temptime);
        this.captureTime.startTime = 2;
        this.captureTime.endTime = 5;
        this.headerIndex = i;
        const strchangedval = "" + _temptime; this.resetCellValue(cellHeaeder, i, strchangedval.replace(".", ":"));
        if (this._Isfortimespent) { this.Addlogtime(); }
        else { this.addlogtimeForMid(); }
      } else {
        this.resetCellValue(cellHeaeder, i, this._tcurrentvalue); this._toastr.error('Logged value should be less than 24 hours', 'Timesheet'); return;
      }
    }
  }

  onhoursCheck(val, headerId) {
    let cvalue = 0;
    if (this._tcurrentvalue != '') { cvalue = (Number(this._tcurrentvalue.replace(":", "."))); }
    let _theaderval = 0; let _returnval = true;
    if (headerId == 1) {
      let tval = this._tlstHeader[0].dayHeader1 != null ? this._tlstHeader[0].dayHeader1 : '0';
      _theaderval = (Number(tval.replace(":", ".")));
    }
    else if (headerId == 2) {
      let tval = this._tlstHeader[0].dayHeader2 != null ? this._tlstHeader[0].dayHeader2 : '0';
      _theaderval = (Number(tval.replace(":", ".")));
    }
    else if (headerId == 3) {
      let tval = this._tlstHeader[0].dayHeader3 != null ? this._tlstHeader[0].dayHeader3 : '0';
      _theaderval = (Number(tval.replace(":", ".")));
    }
    else if (headerId == 4) {
      let tval = this._tlstHeader[0].dayHeader4 != null ? this._tlstHeader[0].dayHeader4 : '0';
      _theaderval = (Number(tval.replace(":", ".")));
    }
    else if (headerId == 5) {
      let tval = this._tlstHeader[0].dayHeader5 != null ? this._tlstHeader[0].dayHeader5 : '0';
      _theaderval = (Number(tval.replace(":", ".")));
    }
    else if (headerId == 6) {
      let tval = this._tlstHeader[0].dayHeader6 != null ? this._tlstHeader[0].dayHeader6 : '0';
      _theaderval = (Number(tval.replace(":", ".")));
    }
    else if (headerId == 7) {
      let tval = this._tlstHeader[0].dayHeader7 != null ? this._tlstHeader[0].dayHeader7 : '0';
      _theaderval = (Number(tval.replace(":", ".")));
    }
    const pp = (_theaderval - cvalue);
    _theaderval = pp + Number(val);
    const _temptime = this.numberToTimeCalculate(Number(_theaderval));
    _returnval = Number(_temptime) <= 24 ? true : false;
    if (_returnval) {
      const newstr = "" + _temptime;
      const strchangedval = "" + val;
      this.resetCellValue(headerId, this.headerIndex, strchangedval.replace(".", ":"));
      this.resetfootervalue(headerId, newstr.replace(".", ":"));
    }
    return _returnval;
  }

  resetfootervalue(headerId, _temptime) {
    const headerKey = `dayHeader${headerId}`;
    const localKey = `headerDay${headerId}`;
    this[localKey] = this._tlstHeader[0][headerKey] = _temptime;

    let dayTotals: number[] = [];
    for (let i = 1; i <= 7; i++) {
      const dayVal = this.dynamicArray[this.headerIndex][`day${i}`];
      if (dayVal !== '') {
        dayTotals.push(+dayVal.replace(':', '.'));
      } else {
        dayTotals.push(0);
      }
    }

    // header times for all 7 days
    let totalHours = 0;
    let totalMinutes = 0;
    for (let i = 1; i <= 7; i++) {
      const val = this._tlstHeader[0][`dayHeader${i}`];
      if (val && val !== '') {
        const [h, m] = val.split(':').map(Number);
        totalHours += h;
        totalMinutes += m;
      }
    }

    totalHours += Math.floor(totalMinutes / 60);
    totalMinutes = totalMinutes % 60;

    const tdft = `${totalHours}:${totalMinutes.toString().padStart(2, '0')}`;
    this.headerDayTotal = this.numberToTimeCalculateStr(tdft.replace(':', '.')).replace('.', ':');

    //Update row total
    const rowTotal = dayTotals.reduce((a, b) => a + b, 0);
    const strchangedval = rowTotal.toFixed(2).toString();
    const _temptime1 = this.numberToTimeCalculate(Number(strchangedval.replace(':', '.')));
    this.dynamicArray[this.headerIndex].dayTotal = _temptime1.toString().replace('.', ':');

    this.onUserCapacityCheck();
  }

  public _temptotalval: string = '';
  public _tlstHeader: any = [];
  onChangeSearchSingle(val: any) {
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }

  onChangeSearchSingle1(val: any) {

  }

  onFocusedSingle1(e) {

  }
  onFocusedSingle(e) {
    // do something when input is focused
  }

  onChangeSearch(val: string) {
    // fetch remote data from here    // And reassign the 'data' which is binded to 'data' property.
  }

  public userdetail: any;
  GetUserDetail(UserId: string) {
    this.userManagementService.getUserManagementDetailsById(UserId).pipe(takeUntil(this.unsubscribe)).subscribe({
      next: (result: any) => {   
        this.userdetail = result;
      },
      error: (error) => {
        // Handle the error if needed.
      }
    });
  };
    selectEvent(item) {    
    localStorage.setItem("addtimesheetnotify", "true");
    localStorage.setItem("addtimesheetprof", "true");
    localStorage.setItem("addtimesheetindiv", "true");
    localStorage.setItem("addtimesheetchangepw", "true");
    let obj = this.dynamicArray.filter(u => u.contextId == 0 && u.context == '' && u.name == '');
    obj[0].context = item.contextName;
    obj[0].contextId = item.contextId;
    obj[0].name = item.name;
      this.selectItemByCell(item);      
    // do something with selected item
  }

  selectItemByCell(item) { // Dev: Ramya; CUST-1895; 23Dec2022
    let obj = this.dynamicArray.filter(u => u.contextId == item.contextId);
    let index = this.dynamicArray.findIndex(i => i.contextId == item.contextId);
    const dayname = this.datepipe.transform(new Date(), 'EEEE');
    let dayIndex = 0;
    switch (dayname) {
      case 'Monday': {
        dayIndex = 1;
        break;
      }
      case 'Tuesday': {
        dayIndex = 2;
        break;
      }
      case 'Wednesday': {
        dayIndex = 3;
        break;
      }
      case 'Thursday': {
        dayIndex = 4;
        break;
      }
      case 'Friday': {
        dayIndex = 5;
        break;
      }
    }
    this.IsHiderightBox = true;
    this.onsetdefaultValue(item, index, dayIndex);
    this.focusFunction(item.contextName, item.contextId, item.name, new Date);
  }

  onFocused(e) {
    // do something when input is focused
  }

  WarningPopuponeClose() {
    this.clearWarningPopupdata();
  }

  clearWarningPopupdata() {
    this.WarningPopup.hide(); this.warningmsggroupDelete = ""; this.alertmsg = ""; this.Activities = []; this.contexttype = [];
  }

  public alertmsg: string = ""; public warningmsggroupDelete: string = ""; public _flagForline2: boolean = true;
  WarningPopupOpen() {
    this.WarningPopup.show();
  }

  addcommentbuttonshowhide() {
    this.addcommentbuttonshow = true;
    if (this.strlogtimedetail.length > 0) {
      this.warningmsggroupDelete = "All unsaved data will be lost.";
      this.alertmsg = "Are you sure you want to leave?";
      this.isbulkPublishcancel = true;
      this.isChangeWeekcancel = false;
      this.checktimesheetpopup = true;
      this.WarningPopupOpen();
      return false;
    }
  }

  resetinProperTimeFormat() {
    this.headerDay1 = this.headerDay1.replace(".", ":");
    this.headerDay2 = this.headerDay2.replace(".", ":");
    this.headerDay3 = this.headerDay3.replace(".", ":");
    this.headerDay4 = this.headerDay4.replace(".", ":");
    this.headerDay5 = this.headerDay5.replace(".", ":");
    this.headerDay6 = this.headerDay6.replace(".", ":");
    this.headerDay7 = this.headerDay7.replace(".", ":");
    this.headerDayTotal = this.headerDayTotal.replace(".", ":");
  }

  calculateHeeaderDay(day1,headerDayres) {
    let headerDaytotal = this.numberToTimeCalculateStr(headerDayres.replace(":", "."));
    let headerDay = this.numberToTimeCalculateStr(day1.replace(":", "."));
    const hedday1 = parseFloat(headerDaytotal) - parseFloat(headerDay);
    const roundhedertotal = hedday1.toFixed(2).toString();
    return this.numberToTimeCalculateStr(roundhedertotal);
  }

 updateheaderday() {
  this.dynamicArray = this.tempdynamicArray.filter(element => {
    if (element.contextId === this.actId) {
      this.MatchingElement(element);
      return false; // Don't include in dynamicArray
    }
    return true; // Keep in dynamicArray
  });
  
  this.checkDeleteday = false;
}

MatchingElement(element: any) {
  // Process individual days (1-7)
  for (let day = 1; day <= 7; day++) {
    this.processSingleDay(element, day);
  }
  
  this.headerDayTotal = this.calculateHeeaderDay(
    element.dayTotal, 
    this.headerDayTotal
  );
}

processSingleDay(element: any, dayNumber: number) {
  const dayValue = element[`day${dayNumber}`];
  
  if (dayValue != null && dayValue !== "") {
    const currentHeaderValue = this[`headerDay${dayNumber}`];
    const result = this.calculateHeeaderDay(dayValue, currentHeaderValue);
    
    this[`headerDay${dayNumber}`] = result;
    this._tlstHeader[0][`dayHeader${dayNumber}`] = result;
  }
}

  actId: any = 0;
  publishCheckDel: boolean = false;
  public tempstrlogtimedetail = [];
  timesheetDefaultView() { // Dev: Ramya; CUST-1895; 23Dec2022
    this.onsetdefaultValue(this.dynamicArray[0], 0, 1);
    function startOfWeek(date) { 
      const diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1);
      return new Date(date.setDate(diff));
    }
    this.monInput.nativeElement.focus();
    this.focusFunction(this.dynamicArray[0].context, this.dynamicArray[0].contextId, this.dynamicArray[0].name, startOfWeek(new Date));
  }

  waringpopuponeyes() {
    this.actId = 0;
    this.selectedItemsDays = null;
    if (!this.isbulkPublishcancel) {      
      this.publishCheckDel = true;
      this.tempstrlogtimedetail= this.listcaptureTime = [];
      this.tempstrlogtimedetail = this.strlogtimedetail;
      this.strlogtimedetail = [];
      this.actId = this.Activities[0];
      this.tempstrlogtimedetail.forEach(element => {
        let res = JSON.parse(element);
        if (res.jobId != this.actId) {
          this.strlogtimedetail.push(element);
        }
      })
      this.checkDeleteday = true;
      if (this.checktimesheetpopup) {
        this.GetTimeSheetBillableDetailsList();
        this.getWeeklyTimeSheetDetailsList();
        this.checktimesheetpopup = false;      
      }      
      this.onDeleteweeklyTimeLog();
      this.updateheaderday();
      this.getTimeSheetDetailsList();
      // delete log is calling;
    } else {
      if (this.ispreviousdate) {
        this.prevousdate();
      }
      else if (this.isnextdate) {
        this.nextdate();
      }
      else if (!this.isTimesheetcancel && !this.isChangeWeekcancel) {
        this.setMyStatesAsActive(this.temp_selectedUser, this.temp_IsUserSelected, this.temp_selectedUname);
        this.temp_selectedUser = ''; this.temp_IsUserSelected = ''; this.temp_selectedUname = '';
      }
      else if (this.isChangeWeekcancel) {
        this.onChanges(this._tempOnchangeEvent);
      }
      this.clearWarningPopupdata();
      this.strlogtimedetail = this.listcaptureTime = [];
      this.GetTimeSheetBillableDetailsList(); this.getWeeklyTimeSheetDetailsList(); this.isbulkPublishcancel = false;
      this.isChangeWeekcancel = true;
    }
    this.ispreviousdate = false; this.isnextdate = false;
    setTimeout(() => {
      this.resetinProperTimeFormat();
    }, 4000);
  } 

  cleartemppublishdata() {
    this.strlogtimedetail = this.listcaptureTime = this.deletecontext = [];
  }

  RemoveEntry(Name: any) {
    this.warningmsggroupDelete = "Timesheet entry for '" + Name + "' will be permanently deleted.";
    this.alertmsg = "Are you sure to continue?"; this.isbulkPublishcancel = false;
    this.WarningPopupOpen();    
  }

  // ---------#regionStart KLOUD1048
  onDeleteChange(i) {
    const context = this.dynamicArray[i].context;
    const element = this.dynamicArray[i].contextId;
    this.Activities.push(element);
    this.contexttype.push(context);
    this.RemoveEntry(this.dynamicArray[i].name);
    if (this.strlogtimedetail.length == 0) {
      const checkEmpty = this.dynamicArray.filter(checkEmpty => checkEmpty.day1 == "" && checkEmpty.day2 == "" && checkEmpty.day3 == "" && checkEmpty.day4 == "" && checkEmpty.day5 == "" && checkEmpty.day6 == "" && checkEmpty.day7 == "");
      if (checkEmpty.length=0) {
        this.GetTimeSheetBillableDetailsList();
        this.getWeeklyTimeSheetDetailsList();
      }
    }
  }

  public deletecontext: any = []; public _tempdynamicArray: any = [];
  onDeleteweeklyTimeLog() {
    const request1 = {
      ContextId: this.Activities[0],
      ContextType: this.contexttype[0],
      Fromdate: this.fromdate,
      Todate: this.todate
    }
    this.Activities = JSON.stringify(this.Activities);
    this.contexttype = JSON.stringify(this.contexttype);
    const request = {
      ContextId: this.Activities,
      ContextType: this.contexttype,
      Fromdate: this.fromdate,
      Todate: this.todate
    }
    if (this.strlogtimedetail.length > 0) {
      this.dynamicArray = this.dynamicArray.filter(m => m.context != request1.ContextId && m.context != request1.ContextType);
    }
    this.timeCapturedforCell = false;
    this._timesheetService.DeleteweeklyTimeLog(request).pipe(takeUntil(this.unsubscribe)).subscribe((response: any) => {
      if (response) {
        this._toastr.success("TimeLog is sucessfully Deleted", 'Timesheet');
        this.IsHiderightBox = false;
        this.Activities = [];
        this.contexttype = [];
        if (this.strlogtimedetail.length == 0) {
          this.getWeeklyTimeSheetDetailsList();      //Sasmit, 25-Aug-2022, excel-issue:Refresh Billable Hours
        }
      }
      else {
        this._toastr.error("Something went wrong", 'Timesheet');
        this.Activities = [];
        this.contexttype = [];
         this.getWeeklyTimeSheetDetailsList();     //Sasmit, 25-Aug-2022, excel-issues:Refresh Billable Hours
      }
      setTimeout(() => {
       this.timesheetDefaultView();
      }, 1000);
     
    })
    this.clearWarningPopupdata();
  }

  public isbulkPublishcancel: boolean = false;
  public isTimesheetcancel: boolean = false;
  public ispreviousdate: boolean = false;
  public isnextdate: boolean = false;
  cancelbulkPublish(calltype) {
    if (calltype == "cancelpublish") {
      this.isTimesheetcancel = true;     
      localStorage.setItem("addtimesheetnotify", "false");
      localStorage.setItem("addtimesheetprof", "false");
      localStorage.setItem("addtimesheetindiv", "false");
      localStorage.setItem("addtimesheetchangepw", "false");
    }
    else {
      this.isTimesheetcancel = false;
    }
    if (calltype == "previousdate") {
      this.ispreviousdate = true;
    }
    else {
      this.ispreviousdate = false;
    }
    if (calltype == "nextdate") {
      this.isnextdate = true;
    }
    else {
      this.isnextdate = false;
    }
    if (this.strlogtimedetail.length > 0) {
      this.warningmsggroupDelete = "All unsaved data will be lost.";
      this.alertmsg = "Are you sure you want to leave?";
      this.isbulkPublishcancel = true;
      this.isChangeWeekcancel = false;
      this.WarningPopupOpen(); return false;
    }
  }

  public isChangeWeekcancel: boolean = true;
  checkChangeWeekcancel() {
    this.isChangeWeekcancel = false;
    if (this.strlogtimedetail.length > 0) {
      this.warningmsggroupDelete = "All unsaved data will be lost.";
      this.alertmsg = "Are you sure you want to leave?";
      this.isbulkPublishcancel = true;
      this.isChangeWeekcancel = true;
      this.WarningPopupOpen();
      return false;
    }
  }

  checkWeekChangePrevious(){
    if (this.strlogtimedetail.length > 0) {
      this.cancelbulkPublish('previousdate');
    }
    else {
      this.prevousdate();
    }
  }

  checkWeekChangeNext() {
    if (this.strlogtimedetail.length > 0) {
      this.cancelbulkPublish('nextdate');
    }
    else {
      this.nextdate();
    }
  }  
  
  postbulktimelog() {
    if (this.strlogtimedetail.length > 0) {
      this.listcaptureTime = [];
      this.strlogtimedetail.forEach(childObj => {
        this.listcaptureTime.push(JSON.parse(childObj));
      });      
      localStorage.setItem("addtimesheetnotify", "false");
      localStorage.setItem("addtimesheetprof", "false");
      localStorage.setItem("addtimesheetindiv", "false");
      localStorage.setItem("addtimesheetchangepw", "false");
      this.logtimeService.BulkAddLogTime(this.listcaptureTime).pipe(takeUntil(this.unsubscribe)).subscribe(result => {
          if (result.success) {
            this.selectedItemsDays = [];
            this.listcaptureTime = this.strlogtimedetail = [];
            this._toastr.success('successfully captured log time', 'Timesheet');
            this.timeCapturedforCell = true;
            let day1 = 0;
            let day2 = 0;
            let day3 = 0;
            let day4 = 0;
            let day5 = 0;
            let day6 = 0;
            let day7 = 0;
            if (this.dynamicArray[this.headerIndex].day1 !== '') {
              day1 = +this.dynamicArray[this.headerIndex].day1.replace(':', '.');
            }
            if (this.dynamicArray[this.headerIndex].day2 !== '') {
              day2 = +this.dynamicArray[this.headerIndex].day2.replace(':', '.');;
            }
            if (this.dynamicArray[this.headerIndex].day3 !== '') {
              day3 = +this.dynamicArray[this.headerIndex].day3.replace(':', '.');;
            }
            if (this.dynamicArray[this.headerIndex].day4 !== '') {
              day4 = +this.dynamicArray[this.headerIndex].day4.replace(':', '.');;
            }
            if (this.dynamicArray[this.headerIndex].day5 !== '') {
              day5 = +this.dynamicArray[this.headerIndex].day5.replace(':', '.');;
            }
            if (this.dynamicArray[this.headerIndex].day6 !== '') {
              day6 = +this.dynamicArray[this.headerIndex].day6.replace(':', '.');;
            }
            if (this.dynamicArray[this.headerIndex].day7 !== '') {
              day7 = +this.dynamicArray[this.headerIndex].day7.replace(':', '.');;
            }
            const dayTotal = day1 + day2 + day3 + day4 + day5 + day6 + day7;

            this.dynamicArray[this.headerIndex].dayTotal = dayTotal.toFixed(2).toString();
            this.getWeeklyTimeSheetDetailsList();
            this.GetTimeSheetBillableDetailsList();
            this.getTimeSheetDetailsList();
            setTimeout(() => {
              this.timesheetDefaultView();
            }, 1000);
          }
          else if (result.message == "EXISTS") {
            this._toastr.error('Final Invoice is exists for this job', 'Timesheet');
          } else if (result.message == "HolidayLeave") { }
          else {
            alert(result.message);
          }

        }, error => { this._toastr.error(error.message, 'Timesheet') });
    }
    else {
      this._toastr.error('Please select a Job and Enter Time to publish.', 'Error!');      //Sasmit, 25-Aug-2022, excel-issues
      return;
    }
    if (this.publishCheckDel) {
      this.publishCheckDel = false;
      this.getWeeklyTimeSheetDetailsList();
      this.GetTimeSheetBillableDetailsList();
      this.getTimeSheetDetailsList();
    }
    setTimeout(() => {
      this.resetinProperTimeFormat();
    }, 4000);
  }
  public strlogtimedetail = [];
  addlogtimeForMid() {    
    if (this.captureTime.loggedTime == '') { this.captureTime.loggedTime = 0; }
    this.captureTime.taskId = 0
    if (this.ct_origin == 'job') { this.captureTime.mastertimesheetId = this.captureTime.masterholidayId = this.captureTime.clientId = this.captureTime.entityId = 0; this.captureTime.isBillable = true; }
    else if (this.ct_origin == 'msid') { this.captureTime.jobId = this.captureTime.masterholidayId = this.captureTime.entityId = this.captureTime.clientId = 0; this.captureTime.isBillable = false; }
    else if (this.ct_origin == 'mhid') { this.captureTime.jobId = this.captureTime.mastertimesheetId = this.captureTime.entityId = this.captureTime.clientId = 0; this.captureTime.isBillable = false; }
    if (this.captureTime.taskId = undefined) { this.captureTime.taskId = 0 }

    if (this.captureTime.endDate == '' || this.captureTime.endDate == undefined) { this.captureTime.endDate = this.captureTime.startDate = new Date(); }
    this.captureTime.strtdate = this.datepipe.transform(this.captureTime.endDate, 'dd/MM/yyyy');
    this.captureTime.taskList = '';
    this.captureTime.statusId = 4;  // for approved
    let strObj = JSON.stringify(this.captureTime);
    this.strlogtimedetail.push(strObj);
  }
  Addlogtime() {
    this.strlogtimedetail = [];   // inside tis method this :bulk timelog  will be empty.
    if (this.captureTime.loggedTime == '') { this.captureTime.loggedTime = 0; }
    this.captureTime.taskId = 0
    if (this.ct_origin == 'job') { this.captureTime.mastertimesheetId = this.captureTime.masterholidayId = this.captureTime.clientId = this.captureTime.entityId = 0; this.captureTime.isBillable = true; }
    else if (this.ct_origin == 'msid') { this.captureTime.jobId = this.captureTime.masterholidayId = this.captureTime.entityId = this.captureTime.clientId = 0; this.captureTime.isBillable = false; }
    else if (this.ct_origin == 'mhid') { this.captureTime.jobId = this.captureTime.mastertimesheetId = this.captureTime.entityId = this.captureTime.clientId = 0; this.captureTime.isBillable = false; }
    if (this.captureTime.taskId = undefined) { this.captureTime.taskId = 0 }

    if (this.captureTime.endDate == '' || this.captureTime.endDate == undefined) { this.captureTime.endDate = this.captureTime.startDate = new Date(); }
    this.captureTime.strtdate = this.datepipe.transform(this.captureTime.endDate, 'dd/MM/yyyy');
    this.captureTime.taskList = '';
    this.captureTime.statusId = 4;
    this.logtimeService.PostAddLogTime(this.captureTime).pipe(takeUntil(this.unsubscribe)).subscribe(result => {
        if (result.success) {
          this._toastr.success('successfully captured log time', 'Timesheet');
          this.timeCapturedforCell = true;
          let day1 = 0;
          let day2 = 0;
          let day3 = 0;
          let day4 = 0;
          let day5 = 0;
          let day6 = 0;
          let day7 = 0;
          if (this.dynamicArray[this.headerIndex].day1 !== '') {
            day1 = +this.dynamicArray[this.headerIndex].day1.replace(':', '.');
          }
          if (this.dynamicArray[this.headerIndex].day2 !== '') {
            day2 = +this.dynamicArray[this.headerIndex].day2.replace(':', '.');;
          }
          if (this.dynamicArray[this.headerIndex].day3 !== '') {
            day3 = +this.dynamicArray[this.headerIndex].day3.replace(':', '.');;
          }
          if (this.dynamicArray[this.headerIndex].day4 !== '') {
            day4 = +this.dynamicArray[this.headerIndex].day4.replace(':', '.');;
          }
          if (this.dynamicArray[this.headerIndex].day5 !== '') {
            day5 = +this.dynamicArray[this.headerIndex].day5.replace(':', '.');;
          }
          if (this.dynamicArray[this.headerIndex].day6 !== '') {
            day6 = +this.dynamicArray[this.headerIndex].day6.replace(':', '.');;
          }
          if (this.dynamicArray[this.headerIndex].day7 !== '') {
            day7 = +this.dynamicArray[this.headerIndex].day7.replace(':', '.');;
          }
          const dayTotal = day1 + day2 + day3 + day4 + day5 + day6 + day7;

          this.dynamicArray[this.headerIndex].dayTotal = dayTotal.toFixed(2).toString();
          this.getWeeklyTimeSheetDetailsList();
          this.GetTimeSheetBillableDetailsList();
        }
        else if (result.message == "EXISTS") {
          this._toastr.error('Final Invoice is exists for this job', 'Timesheet');
        } else if (result.message == "HolidayLeave") { }
        else {
          alert(result.message);
        }

      }, error => { this._toastr.error(error.message, 'Timesheet') });
  }
  addLogComment() {
    if (this._comment.comment == '') { this._toastr.error("Comment required !", 'Timesheet'); return; }
    if (this.timespentField == '' || this.timespentField == null || this.timespentField == 0) { this._toastr.error("Timelog required for comment!", 'Timesheet'); return; }
    else if (this._comment.contextId == undefined || this._comment.contextId == null || this._comment.contextId == 0) { this._toastr.error("please select item name required !", 'Timesheet'); return; }

    this._comment.weekStart_At = this.w1;
    this._comment.weekEnd_At = this.w7; this._comment.commentId = 0;
    this._comment.strtdate = this.datepipe.transform(this._comment.commentDate, 'dd/MM/yyyy');
    let userlst = [];
    let x = this._comment.comment.replace(/(\r\n|\n|\r)/gm, "").split("@");
    let z;
    if (x.length > 0) {
      x.forEach(childObj => {
        childObj = childObj.split(" ")[0];
        userlst.push(childObj);
      });
      if (userlst.length > 0) {
        let y = userlst.filter(t => t != "" && this.usersdata.findIndex(u => u.firstName == t.trim()) > -1);
        z = y.map(firstName => this.usersdata.find(s => s.firstName == firstName.trim()).userId);
        this._comment.TaggedUsers = z.join(",");
      }
    }
    this.logtimeService.PostTimeLogComment(this._comment).pipe(takeUntil(this.unsubscribe)).subscribe(result => {
        if (result.success) {
          this._toastr.success('successfully captured comment', 'Timesheet');
          this.onClearComment(); this.dynamicName = this.dynamicMilestone = '';
          this.setStateAsActive(''); this.setMyStatesAsActive(this.tUserid, false, 'My Timesheet');
        }
        else {
          this._toastr.error(result.message, 'Timesheet')
        }
      }, error => { this._toastr.error(error.message, 'Timesheet') });
  }
  twoDaysAhead1: any
  fourDaysAhead: any; monthlyDataView: any = [];
  firstDay: any;
  secondDay: any;
  thirddDay: any;
  Day4: any
  Day5: any;
  Day6: any
  Day7: any
  Day8: any
  Day9: any
  Day10: any
  Day11: any
  Day12: any
  Day13: any
  Day14: any
  Day15: any
  Day16: any
  Day17: any
  Day18: any
  Day19: any
  Day20: any
  Day21: any
  Day22: any
  Day23: any
  Day24: any
  Day25: any
  Day26: any
  Day27: any
  Day28: any
  Day29: any
  Day30: any
  Day31: any
  lastDay: any;
  Day1class: any;
  Day2class: any;
  Day3class: any;
  Day4class: any;
  Day5class: any;
  Day6class: any;
  Day7class: any;
  Day8class: any;
  Day9class: any;
  Day10class: any;
  Day11class: any;
  Day12class: any;
  Day13class: any;
  Day14class: any;
  Day15class: any;
  Day16class: any;
  Day17class: any;
  Day18class: any;
  Day19class: any;
  Day20class: any;
  Day21class: any;
  Day22class: any;
  Day23class: any;
  Day24class: any;
  Day25class: any;
  Day26class: any;
  Day27class: any;
  Day28class: any;
  Day29class: any;
  Day30class: any;
  Day31class: any;
  isHoliday1: boolean = false; isHoliday2: boolean = false; isHoliday3: boolean = false; isHoliday4: boolean = false; isHoliday5: boolean = false; isHoliday6: boolean = false; isHoliday7: boolean = false; isHoliday8: boolean = false; isHoliday9: boolean = false; isHoliday10: boolean = false; // Developer: Ramya;  Ticket: CUST-1113;  Date: 28-Apr-2022
  isHoliday11: boolean = false; isHoliday12: boolean = false; isHoliday13: boolean = false; isHoliday14: boolean = false; isHoliday15: boolean = false; isHoliday16: boolean = false; isHoliday17: boolean = false; isHoliday18: boolean = false; isHoliday19: boolean = false; isHoliday20: boolean = false;
  isHoliday21: boolean = false; isHoliday22: boolean = false; isHoliday23: boolean = false; isHoliday24: boolean = false; isHoliday25: boolean = false; isHoliday26: boolean = false; isHoliday27: boolean = false; isHoliday28: boolean = false; isHoliday29: boolean = false; isHoliday30: boolean = false; isHoliday31: boolean = false; 
  clearDayClass() {
    this.firstDay = '';
    this.secondDay = '';
    this.thirddDay = '';
    this.Day4 = '';
    this.Day5 = '';;
    this.Day6 = '';
    this.Day7 = '';
    this.Day8 = '';
    this.Day9 = '';
    this.Day10 = '';
    this.Day11 = '';
    this.Day12 = '';
    this.Day13 = '';
    this.Day14 = '';
    this.Day15 = '';
    this.Day16 = '';
    this.Day17 = '';
    this.Day18 = '';
    this.Day19 = '';
    this.Day20 = '';
    this.Day21 = '';
    this.Day22 = '';
    this.Day23 = '';
    this.Day24 = '';
    this.Day25 = '';
    this.Day26 = '';
    this.Day27 = '';
    this.Day28 = '';
    this.Day29 = '';
    this.Day30 = '';
    this.Day31 = '';
    this.lastDay = '';
    this.Day1class = '';
    this.Day2class = '';
    this.Day3class = '';
    this.Day4class = '';
    this.Day5class = '';
    this.Day6class = '';
    this.Day7class = '';
    this.Day8class = '';
    this.Day9class = '';
    this.Day10class = '';
    this.Day11class = '';
    this.Day12class = '';
    this.Day13class = '';
    this.Day14class = '';
    this.Day15class = '';
    this.Day16class = '';
    this.Day17class = '';
    this.Day18class = '';
    this.Day19class = '';
    this.Day20class = '';
    this.Day21class = '';
    this.Day22class = '';
    this.Day23class = '';
    this.Day24class = '';
    this.Day25class = '';
    this.Day26class = '';
    this.Day27class = '';
    this.Day28class = '';
    this.Day29class = '';
    this.Day30class = '';
    this.Day31class = '';
    this.isHoliday1 = false; this.isHoliday2 = false; this.isHoliday3 = false; this.isHoliday4 = false; this.isHoliday5 = false; this.isHoliday6 = false; this.isHoliday7 = false; this.isHoliday8 = false; this.isHoliday9 = false; this.isHoliday10 = false; this.isHoliday11 = false; this.isHoliday12 = false; this.isHoliday13 = false; this.isHoliday14 = false; this.isHoliday15 = false; // Developer: Ramya;  Ticket: CUST-1113;  Date: 28-Apr-2022
    this.isHoliday16 = false; this.isHoliday17 = false; this.isHoliday18 = false; this.isHoliday19 = false; this.isHoliday20 = false; this.isHoliday21 = false; this.isHoliday22 = false; this.isHoliday23 = false; this.isHoliday24 = false; this.isHoliday25 = false; this.isHoliday26 = false; this.isHoliday27 = false; this.isHoliday28 = false; this.isHoliday29 = false; this.isHoliday30 = false; this.isHoliday31 = false;  
  }
  crtDt:any;
  checkMonth: any;
  getMonthlyTimeSheetDetailsList() {
    const userid = this.IsUserSelected ? this.selectedUser : this.tUserid;
    this.GetUserDetail(userid);

    this._timesheetService
      .GetMonthlyTimesheetByUserSelection(this.fromdate, userid)
      .pipe(takeUntil(this.unsubscribe)).subscribe((response: any) => {
        if (!response?.length) return;

        this.tempFromDate = this.datepipe.transform(
          new Date(response[0].createdOn),
          'yyyy-MM-d'
        );
        this.tempTodate = this.datepipe.transform(
          new Date(response[response.length - 1].createdOn),
          'yyyy-MM-d'
        );
        this.getWeeklyTimeSheetHolidayDetailslist();

        const currentMonth = this.datepipe.transform(this.fromdate, 'MMMM');
        if (this.checkMonth !== currentMonth) {
          this.checkMonth = currentMonth;
          this.clearDayClass();
        }

        const startOfWeek = (date: Date) => {
          const diff =
            date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1);
          return new Date(date.setDate(diff));
        };

        this.crtDt = startOfWeek(new Date());

        setTimeout(() => {
          this.monthlyDataView = response;
          const datese = new Date();
          this.lastDay = new Date(datese.getFullYear(), datese.getMonth() + 1, 0);

          // build day-wise classes dynamically
          this.dateCustomClasses = this.monthlyDataView.map((item, index) => {
            const dayNumber = index + 1;
            const currentDay = new Date(item.createdOn);

            // store in dynamic Day1, Day2 ...
            (this as any)[`Day${dayNumber}`] = currentDay;

            // check holiday flag if available
            const holidayFlag = (this as any)[`isHoliday${dayNumber}`] ?? false;

            let cssClass = '';
            if (this.crtDt.getTime() === currentDay.getTime()) {
              cssClass = '';
            } else if (holidayFlag) {
              cssClass = 'holiday-color';
            } else if (currentDay < this.mon1) {
              if (item.duration < 7) {
                cssClass =
                  currentDay.getDay() === 0 || currentDay.getDay() === 6
                    ? 'text-dark bg-light'
                    : 'bg-danger';
              } else {
                cssClass = 'text-dark bg-light';
              }
            }

            // assigning css class also in Day1class, Day2class ...
            (this as any)[`Day${dayNumber}class`] = cssClass;

            return { date: currentDay, classes: [cssClass, ''] };
          });
        }, 1000);
      });
  }

  getBillablehours() {
    let resMinVal: string;

    this.headerDayTotal = this.headerDayTotal.replace(":", ".");
    this.nonbillabletimeVal = this.nonbillabletimeVal.replace(":", ".");

    const hdt = this.headerDayTotal.split(".");
    const nbtv = this.nonbillabletimeVal.split(".");

    const tbh = Number(hdt[0]) - Number(nbtv[0]);
    const tbm = Number(hdt[1]) - Number(nbtv[1]);

    this.nonbillable = (Number(this.nonbillabletimeVal) / Number(this.headerDayTotal)) * 100;
    this.nonbillable = parseInt(parseFloat(this.nonbillable.toString()).toFixed(0));

    this.nonbillabletimeVal = this.nonbillabletimeVal.replace(".", ":");

    if (tbh > 0) {
      if (tbm > 0) {
        resMinVal = tbm < 10 ? "0" + tbm : "" + tbm;
        this.billabletimeVal = tbh + ":" + resMinVal;
      } else {
        const resval = Number(hdt[1]) + 60;
        const aftertbh = Number(hdt[0]) - 1;
        let finalResultHr = aftertbh - Number(nbtv[0]);
        let finalResultMin = resval - Number(nbtv[1]);

        if (finalResultMin === 60) {
          finalResultMin = 0;
          finalResultHr += 1;
        }

        finalResultMin = parseInt(parseFloat(finalResultMin.toString()).toFixed(2));

        resMinVal = finalResultMin <= 9 ? "0" + finalResultMin : "" + finalResultMin;
        this.billabletimeVal = finalResultHr + ":" + resMinVal;
      }
    } else {
      this.billabletimeVal = "00:00";
    }

    this.billabletimeVal = this.billabletimeVal.replace(":", ".");
    this.billable = (Number(this.billabletimeVal) / Number(this.headerDayTotal)) * 100;
    this.billable = parseInt(parseFloat(this.billable.toString()).toFixed(0));

    this.billabletimeVal = this.billabletimeVal.replace(".", ":");
    this.headerDayTotal = this.headerDayTotal.replace(".", ":");

    this.billable = isNaN(this.billable) ? 0 : this.billable;
    this.nonbillable = isNaN(this.nonbillable) ? 0 : this.nonbillable;
  }

  public _lstWeeklyHoliday: any = [];
  getWeeklyTimeSheetHolidayDetailslist() {
    this._timesheetService.GetWeeklyTimesheetHolidayDetail(this.tempFromDate, this.tempTodate, true)
      .pipe(takeUntil(this.unsubscribe)).subscribe({
        next: (response: any) => {
          if (response) {
            this._lstWeeklyHoliday = response;

            for (let i = 0; i < this._lstWeeklyHoliday.length; i++) {
              this[`isHoliday${i + 1}`] = this._lstWeeklyHoliday[i]?.isHoliday || false;
            }
          }
        },
        error: (error) => {
          this._toastr.error(error.message, 'Timesheet');
        }
      });
  }

  validateHolidayDetails() { // Developer: Ramya;  Ticket: CUST-1169;  Date: 05-May-2022
    let mondate = new Date(this._lstWeeklyHoliday[0].holidayDate);
    let tuesdate = new Date(this._lstWeeklyHoliday[1].holidayDate);
    let wedmondate = new Date(this._lstWeeklyHoliday[2].holidayDate);
    let thursdate = new Date(this._lstWeeklyHoliday[3].holidayDate);
    let fridate = new Date(this._lstWeeklyHoliday[4].holidayDate);

    if (mondate < this.mon1) {
      this.IsMonCheckDate = true;
    } else {
      this.IsMonCheckDate = false;
    }
    if (tuesdate < this.mon1) {
      this.IstueCheckDate = true;
    } else {
      this.IstueCheckDate = false;
    }
    if (wedmondate < this.mon1) {
      this.IswedCheckDate = true;
    } else {
      this.IswedCheckDate = false;
    }
    if (thursdate < this.mon1) {
      this.IsthursCheckDate = true;
    } else {
      this.IsthursCheckDate = false;
    }
    if (fridate < this.mon1) {
      this.IsfriCheckDate = true;
    } else {
      this.IsfriCheckDate = false;
    }
  }

  getWeeklyTimeSheetHolidayDetails() {
    this._timesheetService.GetWeeklyTimesheetHolidayDetail(this.fromdate, this.todate, true).pipe(takeUntil(this.unsubscribe)).subscribe((response: any) => {
      if (response) {        
        this._lstWeeklyHoliday = response; 
        this.validateHolidayDetails();
        this.IsmonHolidayHighlighter = this._lstWeeklyHoliday[0].holidayName;
        this.IstueHolidayHighlighter = this._lstWeeklyHoliday[1].holidayName;
        this.IswedHolidayHighlighter = this._lstWeeklyHoliday[2].holidayName;
        this.IsthursHolidayHighlighter = this._lstWeeklyHoliday[3].holidayName;
        this.IsfriHolidayHighlighter = this._lstWeeklyHoliday[4].holidayName;
        this.IssatHolidayHighlighter = this._lstWeeklyHoliday[5].holidayName;
        this.IssunHolidayHighlighter = this._lstWeeklyHoliday[6].holidayName;
      }
    }, error => {
      this._toastr.error(error.message, 'Timesheet');
    });
  }
  nbhrs: any;
  nbmins: any;
  isbillable1: any;
  getWeeklyTimeSheetDetailsList() {
    this.getMonthlyTimeSheetDetailsList();
    this.getWeeklyTimeSheetHolidayDetails();
    const userid = this.IsUserSelected ? this.selectedUser : this.tUserid; this.GetUserDetail(userid);
      this._timesheetService.GetWeeklyTimesheetByUserSelection(this.fromdate, this.todate, userid).pipe(takeUntil(this.unsubscribe)).subscribe((response: any) => {
      if (response) {
        this.weeklyList = response._lstMain;
        const newlst = [];

        this.nonbillabletimeVal = '';
        this.nbhrs = '0';
        this.nbmins = '0';
        this.weeklyList.forEach(childObj => {
          let tdft = '' + childObj.dayTotal;

          if (childObj.type == "Holiday" || childObj.type == "Other" || childObj.type == "Leave") {
            childObj.dayTotal = '' + this.numberToTimeCalculateStr(tdft.replace(":", "."));
            childObj.dayTotal = '' + childObj.dayTotal.replace(".", ":");
            newlst.push(childObj);
            const rnbhrs = childObj.dayTotal.split(":");
            this.nbhrs = parseInt(this.nbhrs) + parseInt(rnbhrs[0]);
            this.nbmins = parseInt(this.nbmins) + parseInt(rnbhrs[1]);
          } else {
            childObj.dayTotal = '' + this.numberToTimeCalculateStr(tdft.replace(":", "."));
            childObj.dayTotal = '' + childObj.dayTotal.replace(".", ":");
            newlst.push(childObj);
          }
        });
        let mins = "";
        if (this.nbmins > 59) {
          let finalMin = "" + this.nbmins / 60;
          finalMin = parseFloat(finalMin).toFixed(2);
          const splitMin = finalMin.split('.');


          const val = parseFloat(finalMin) - parseFloat(splitMin[0]);
          let finalsplitMin = "" + val * 60;
          finalsplitMin = parseFloat(finalsplitMin).toFixed(1);
          const resMin = finalsplitMin.split('.');
          if (parseInt(resMin[1]) > 5) {
            parseInt(resMin[0]) + 1;
          }
          mins = "" + parseFloat(resMin[0]);
          this.nbhrs = parseInt(this.nbhrs) + parseInt(splitMin[0]);
        } else {
          if (this.nbmins <= 9)
            mins = "0" + this.nbmins;
          else
            mins = this.nbmins;
        }
        this.nonbillabletimeVal = this.nbhrs + ":" + mins;
        this.weeklyList = newlst.length > 0 ? newlst : response._lstMain;
        const headerList = response._lstRowHeader; this._tlstHeader = response._lstRowHeader;
        this.headerDay1 = (headerList[0].dayHeader1 == null || headerList[0].dayHeader1 == undefined ? "0" : headerList[0].dayHeader1);
        this.headerDay2 = (headerList[0].dayHeader2 == null || headerList[0].dayHeader2 == undefined ? "0" : headerList[0].dayHeader2);
        this.headerDay3 = (headerList[0].dayHeader3 == null || headerList[0].dayHeader3 == undefined ? "0" : headerList[0].dayHeader3);
        this.headerDay4 = (headerList[0].dayHeader4 == null || headerList[0].dayHeader4 == undefined ? "0" : headerList[0].dayHeader4);
        this.headerDay5 = (headerList[0].dayHeader5 == null || headerList[0].dayHeader5 == undefined ? "0" : headerList[0].dayHeader5);
        this.headerDay6 = (headerList[0].dayHeader6 == null || headerList[0].dayHeader6 == undefined ? "0" : headerList[0].dayHeader6);
        this.headerDay7 = (headerList[0].dayHeader7 == null || headerList[0].dayHeader7 == undefined ? "0" : headerList[0].dayHeader7);

        this.headerDay1 = '' + this.numberToTimeCalculateStr(this.headerDay1.replace(":", "."));
        this.headerDay2 = '' + this.numberToTimeCalculateStr(this.headerDay2.replace(":", "."));
        this.headerDay3 = '' + this.numberToTimeCalculateStr(this.headerDay3.replace(":", "."));
        this.headerDay4 = '' + this.numberToTimeCalculateStr(this.headerDay4.replace(":", "."));
        this.headerDay5 = '' + this.numberToTimeCalculateStr(this.headerDay5.replace(":", "."));
        this.headerDay6 = '' + this.numberToTimeCalculateStr(this.headerDay6.replace(":", "."));
        this.headerDay7 = '' + this.numberToTimeCalculateStr(this.headerDay7.replace(":", "."));


        let latest_date = this.datepipe.transform(this.model.startdate, 'yyyy,M,d');



        this.timeCapturedforCell = false;
        const dt = new Date(latest_date);
        setTimeout(() => {
          if (this.dynamicArray.length != 0) {
            this.IsHiderightBox = true;
            this.monInput.nativeElement.focus();
          } else {
            this.IsHiderightBox = false;
          }
        }, 1000);
        this.fromdate = this.datepipe.transform(startOfWeek(dt), 'yyyy-MM-d');
        this.todate = this.datepipe.transform(endofweed(dt), 'yyyy-MM-d');
        const date = new Date(startOfWeek(dt));
        this.mon = this.datepipe.transform(startOfWeek(dt), 'EE MMM d');
        const myDate = new Date();
        this.mon1 = myDate;

        this.selectedDate = this.mon;

        this.twoDaysAhead = addDays(date, 2);

        this.twoDaysAheada = addDays(date, 1);

        this.twoDaysAhead1 = addDays(date, 3)

        this.fourDaysAhead = addDays(date, 4)
        const fourDaysAhead1 = new Date();
        fourDaysAhead1.setDate(this.mon1.getDate() + 5);
        const fourDaysAhead2 = new Date();
        fourDaysAhead2.setDate(this.mon1.getDate() + 6);

        setTimeout(() => {


        }, 4000);

        if (this.headerDay1 > 7) {
          this.addcssheaderDay1 = 'btn-primary';

        }
        else {

          this.addcssheaderDay1 = 'bg-danger';
        }


        if (this.headerDay2 < 7) {
          this.addcssheaderDay2 = 'bg-danger';

        }
        else {
          this.addcssheaderDay2 = '';
        }
        if (this.headerDay3 < 7) {
          this.addcssheaderDay3 = 'bg-danger';
        }
        else {
          this.addcssheaderDay3 = '';
        }

        if (this.headerDay4 < 7) {

          this.addcssheaderDay4 = 'bg-danger';
        }
        else {

          this.addcssheaderDay4 = '';
        }
        if (this.headerDay5 < 7) {

          this.addcssheaderDay5 = 'bg-danger';
        }
        else {

          this.addcssheaderDay5 = '';
        }

        this.headerDayTotal = response.dayTotal;
        this.getBillablehours();
        if (!this.timeCapturedforCell) {
          this.addRowForGetResult(this.weeklyList); //this.addRow(0);
        }
        if (this.weeklyList.length > 0) {
          if (this._tempindex >= 0) {
            const Type = this.route.snapshot.queryParams["Id"];
            let pdate;
            if (Type != undefined && Type != null && Type != "" && Type != "undefined" && this.dat != undefined) {
              const d = this.dat.split("-");
              const x = d[2].split("T");
              const dtim = new Date(d[0], Number(d[1]) - 1, x[0]);
              pdate = dtim.getTime();
            }
            else {
              if (Type != undefined && Type != null && Type != "" && Type != "undefined" && this.dat != undefined) {
                const d = this.dat.split("-");
                const x = d[2].split("T");
                const dtim = new Date(d[0], Number(d[1]) - 1, x[0]);
                pdate = dtim.getTime();
              }
              else {
                pdate = this.captureTime.startDate == undefined ? new Date(this.model.startdate.getTime()) : new Date(this.captureTime.startDate.getTime());
              }
            }
            this.addRowForGetResult(this.weeklyList);
            if (this.weeklyList != undefined && this.weeklyList[this._tempindex] != undefined) { this.setFinalInvoiceflag(this.weeklyList[this._tempindex].isFinalInvoice); }
            if (this._Isfortimespent) {
              const cdate = this.captureTime.startDate;// new Date(this.captureTime.startDate.getTime() - (24 * 60 * 60 * 1000));
              if (this.weeklyList != undefined && this.weeklyList[this._tempindex] != undefined) {      //  Dev: Sachin Yadav;  Date:16-Sept-2022;   Task: applied if condition for CUST-1589 
                this.focusFunction(this.weeklyList[this._tempindex].context, this.weeklyList[this._tempindex].contextId, this.weeklyList[this._tempindex].name, cdate);
              }
              this.onsetdefaultValue(this.weeklyList[this._tempindex], this._tempcellHeaeder, this._tempindex)
            }
            else {
              this.captureTime.startDate = this.captureTime.startDate == undefined ? this.model.startdate : this.captureTime.startDate;
              if (this.weeklyList != undefined && this.weeklyList[this._tempindex] != undefined) {
                this.focusFunction(this.weeklyList[this._tempindex].context, this.weeklyList[this._tempindex].contextId, this.weeklyList[this._tempindex].name, pdate);
              }
              if (!this.isTabButtonClick) {
                setTimeout(() => {
                  this._tempcellHeaeder = 0;
                  this._tempindex = 0;
                  this.onsetdefaultValue(this.weeklyList[this._tempindex], this._tempcellHeaeder + 1, this._tempindex + 1);
                }, 2000);
              }
              else { this.onsetdefaultValue(this.weeklyList[this._tempindex], this._tempcellHeaeder, this._tempindex + 1); }

            }
          } else {
            this.setFinalInvoiceflag(this.weeklyList[0].isFinalInvoice);
            this.focusFunction(this.weeklyList[0].context, this.weeklyList[0].contextId, this.weeklyList[0].name, this.w1);
            this.onsetdefaultValue(this.weeklyList[0], 1, 0)
          }
        } else {
          this.timespentField = this.dynamicName = '';
        }
        this.headerDay1 = this.headerDay1.replace(".", ":");
        this.headerDay2 = this.headerDay2.replace(".", ":");
        this.headerDay3 = this.headerDay3.replace(".", ":");
        this.headerDay4 = this.headerDay4.replace(".", ":");
        this.headerDay5 = this.headerDay5.replace(".", ":");
        this.headerDay6 = this.headerDay6.replace(".", ":");
        this.headerDay7 = this.headerDay7.replace(".", ":");
        this.getBillablehours();
        this.headerDayTotal = this.headerDayTotal.replace(".", ":");
        setTimeout(() => {
          this.onUserCapacityCheck();
        }, 1000);
      }
      else {
        this.headerDayTotal = '00:00';
        this._toastr.error("Something went wrong", 'Timesheet');
      }
      const Type = this.route.snapshot.queryParams["Id"];
      if (Type != undefined && Type != null && Type != "" && Type != "undefined") {
        const dt2 = this.datepipe.transform(this.dtime, 'dd/MM/yyyy');
        this.GetLogCommentDetails(this.commentjobid);
        this.getTimeSheetCommentByContext(this.commentjobid, "JobId", dt2);
        this.getTimeSheetComment(this.commentjobid, "JobId", dt2);
        this.resetinProperTimeFormat();//
      }
    }, error => {
      const Type = this.route.snapshot.queryParams["Id"];
      if (Type != undefined && Type != null && Type != "" && Type != "undefined") {
        const dt2 = this.datepipe.transform(this.dtime, 'dd/MM/yyyy');
        this.GetLogCommentDetails(this.commentjobid);
        this.getTimeSheetCommentByContext(this.commentjobid, "JobId", dt2);
        this.getTimeSheetComment(this.commentjobid, "JobId", dt2);
      }
    });

    function startOfWeek(date) {
      const diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1);
      return new Date(date.setDate(diff));
    }
    function endofweed(date) {
      const lastday = date.getDate() - (date.getDay() - 1) + 6;
      return new Date(date.setDate(lastday));
    }
    function addDays(date, days) {
      const copy = new Date(Number(date))
      copy.setDate(date.getDate() + days)
      return copy
    }
  }

  onUserCapacityCheck() {
    const hday1 = this.headerDay1.replace(":", ".");
    this.thiscompart = this.datepipe.transform(this.mon1, 'EE d');

    //Dev: Rahul Newara; Date: 225 - 08 - 2022;	User management  enhancement timesheet
    if (this.userdetail.wfhMon != undefined && this.userdetail.wfhMon != '' && this.userdetail.wfhMon != '0.00' && this.userdetail.wfhMon != '0:00') {

      this.IsmonHighlighter = this.checkforUser(this.userdetail.wfhMon, hday1);
    }
    const hday2 = this.headerDay2.replace(":", ".");
    if (this.userdetail.wfhTue != undefined && this.userdetail.wfhTue != '' && this.userdetail.wfhTue != '0.00' && this.userdetail.wfhTue != '0:00') {
      this.IstueHighlighter = this.checkforUser(this.userdetail.wfhTue, hday2);
    }

    const hday3 = this.headerDay3.replace(":", ".");
    if (this.userdetail.wfhWed != undefined && this.userdetail.wfhWed != '' && this.userdetail.wfhWed != '0.00' && this.userdetail.wfhWed != '0:00') {
      this.IswedHighlighter = this.checkforUser(this.userdetail.wfhWed, hday3);
    }
   
    const hday4 = this.headerDay4.replace(":", ".");
    if (this.userdetail.wfhThur != undefined && this.userdetail.wfhThur != '' && this.userdetail.wfhThur != '0.00' && this.userdetail.wfhThur != '0:00') {
      this.IsthursHighlighter = this.checkforUser(this.userdetail.wfhThur, hday4);
    }
  
    const hday5 = this.headerDay5.replace(":", ".");
    if (this.userdetail.wfhFri != undefined && this.userdetail.wfhFri != '' && this.userdetail.wfhFri != '0.00' && this.userdetail.wfhFri != '0:00') {
      this.IsfriHighlighter = this.checkforUser(this.userdetail.wfhFri, hday5);
    }
  
  }

  checkforUser(added: string, actual: string): boolean {
    const addedNum = Number(added.replace(":", "."));
    const actualNum = Number(actual.replace(":", "."));

    return addedNum > actualNum;
  }

  numberToTimeCalculateStr(inputVal: any): string {
    const value = inputVal !== '' && inputVal !== undefined ? Number(inputVal) : 0;

    const decimalTimeString = value.toFixed(2);
    const io = decimalTimeString.split('.');

    if (Number(io[1]) > 59) {
      let c_minute = String(Math.floor(Number(io[1]) % 60));
      if (c_minute.length === 1) {
        c_minute = '0' + c_minute;
      }

      const temp_hours = (Math.floor(Number(io[1]) / 60)).toString().split('.');
      const c_hours = Number(io[0]) + Number(temp_hours[0]);

      return `${c_hours}:${c_minute}`;
    }

    return value.toFixed(2);
  }

 numberToTimeCalculate(inputVal: any): number | string {
  const value = inputVal !== '' && inputVal !== undefined ? Number(inputVal) : 0;

  const decimalTimeString = value.toFixed(2);
  const io = decimalTimeString.split('.');

  if (Number(io[1]) > 59) {
    let c_minute = String(Math.floor(Number(io[1]) % 60));
    if (c_minute.length === 1) {
      c_minute = '0' + c_minute;
    }

    const temp_hours = (Math.floor(Number(io[1]) / 60)).toString().split('.');
    const c_hours = Number(io[0]) + Number(temp_hours[0]);

    const _time = Number(`${c_hours}.${c_minute}`);
    return _time;
  }

  return value.toFixed(2); 
}

  GetTimeSheetBillableDetailsList() {
    const userid = this.IsUserSelected ? this.selectedUser : this.tUserid;
      this._timesheetService.GetTimeSheetBillableDetailsListSelectedUser(this.fromdate, this.todate, userid).pipe(takeUntil(this.unsubscribe)).subscribe((response: any) => {
      this.getWeeklyTimeSheetDetailsList();
      if (response) {
        this.total = Number(response[0].total);
        this.percentagetotal = (this.total) * 2
        this.totalhours = this.total.toString().split(".")[0]; ///before
        this.totalminutes = this.total.toString().split(".")[1];

        this.billable = Number(response[0].billable);
        this.percentagebillable = (this.billable) * 2

        this.billablehours = this.billable.toString().split(".")[0]; ///before
        this.billableminutes = this.billable.toString().split(".")[1];
        this.nonbillable = Number(response[0].nonBillable);
        this.percentagenonbillable = (this.nonbillable) * 2

        this.nonbillablehours = this.nonbillable.toString().split(".")[0]; ///before
        this.nonbillableminutes = this.nonbillable.toString().split(".")[1];
      }
      else {

      }
      const _totaltimeVal = "" + this.numberToTimeCalculate(this.total);
      const _billabletimeVal = "" + this.numberToTimeCalculate(this.billable);
      const _nonbillabletimeVal = "" + this.numberToTimeCalculate(this.nonbillable);
      this.totaltimeVal = _totaltimeVal.replace(".", ":");
      this.billabletimeVal = _billabletimeVal.replace(".", ":");
      this.nonbillabletimeVal = _nonbillabletimeVal.replace(".", ":");
    })
  }

  // ----------------#regionEnd KLOUD1048
  public commentlst: any = []; public _commentloopcontrol: any = [];
  getTimeSheetCommentByContext(id, context, selecteddate) {
    if (id != 0) {
      this.logtimeService.GetAllCommentForContext(id, context, selecteddate).pipe(takeUntil(this.unsubscribe)).subscribe((response: any) => {
        if (response) {
          this._commentloopcontrol = [{ 'context': context, 'contextId': id, 'commentdate': selecteddate }];
          this.commentlst = response;
        }
      });
    }
  }
  getTimeSheetComment(id, context, selecteddate) {
    if (id != 0) {
      const sdate = this.datepipe.transform(selecteddate, 'dd/MM/yyyy');
      if (this._commentloopcontrol != undefined) { this.getTimeSheetCommentByContext(id, context, sdate); }
      else {
        this.getTimeSheetCommentByContext(id, context, sdate);
      }
      this.logtimeService.GetcommentById(id, context, sdate).pipe(takeUntil(this.unsubscribe)).subscribe((response: any) => {
        if (response) {
          this.commentdata = response;
          if (this.commentdata.mileStoneId != undefined && this.commentdata.mileStoneId > 0) {
            this._comment.isCompleted = this.commentdata.isCompleted;
            this._comment.comment = ''; this._comment.commentId = this.commentdata.commentId; this._comment.mileStoneId = this.commentdata.mileStoneId;
          } else {
            this._comment.comment = ''; this._comment.commentId = this.commentdata.commentId;
          }
        }
      })
    }
  }
  templstdata:any = [];
  getTimeSheetDetailsList() {
    this._timesheetService.GetJobListForTimesheetByUserId().pipe(takeUntil(this.unsubscribe)).subscribe((response: any) => {
      if (response) {
        this.lstdata = [];
        this.templstdata = response;
        this.templstdata.forEach(childObj => {      
          const objdata = this.dynamicArray.filter(u => u.contextId == childObj.contextId && u.context == childObj.contextName);
          if (objdata.length == 0) {
            this.lstdata.push(childObj);         
          }
        })

      }
    })
  }
  myFunction() {
    const x = document.getElementById("snackbar");
    x.className = "show";
    setTimeout(function () { x.className = x.className.replace("show", ""); this._currentjobStatusId = 0; this._currentStatus = ''; }, 3000);
  }

  onSubmitStatusChange() {
    if (this._comment.mileStoneId != undefined) {
      let toStatusId = Number(this._comment.mileStoneId);
      let JobId = Number(this._lastjobId);
      if (Number(this._currentjobStatusId) != toStatusId) {
        this.jobService.changeJobStatus(JobId, toStatusId).pipe(takeUntil(this.unsubscribe)).subscribe(result => {
            if (result != undefined) {
              if (result) {
                this._toastr.success("Job Status updated sucessfully.", 'Timesheet');     //Sasmit, 25-Aug-2022, excel issues.
                this.onGetMileStoneOnly(JobId);
                //this.myFunction();              //Sasmit, 25-Aug-2022, commented for displaying toastr message on page. 
              }
            }
            else {
              this._toastr.error("Something went wrong, please try again!", 'Timesheet');
            }
          }, error => { this._toastr.error(error.message, 'Timesheet') });
      }
    }
  }

  onGetMileStoneOnly(jobId) {
    this._timesheetService.GetMileStoneByJobId(jobId).pipe(takeUntil(this.unsubscribe)).subscribe((response: any) => {
      if (response) {
        this.lstMilestonedata = response;

      }
    })
  }

  selectchkStatus() {
    if (this.IsDisablestatusChange) {
      this.IsselectStatuschk = false;
    }
    else { this.IsselectStatuschk = !this.IsselectStatuschk }
    setTimeout(() => {
      if (this.IsselectStatuschk == true) { this.IsselectStatuschk = false; }
      else {
        this.IsselectStatuschk = true;
      }
    }, 500);
    if (this.IsUserSelected)
      this.IsselectStatuschk = !this.IsselectStatuschk;
  }
  public IsselectStatuschk: boolean = false;
  setMyStatesAsActive(strUserId, flag, name) {
    this.IsMytimesheet = !flag;
    this.IsUserSelected = flag; this.selectedUser = strUserId; this.selectedUname = name;
    if (flag) {// default my timesheet  
      this.getTimeSheetDetailsList();
    } this.timeCapturedforCell = false; this.IsselectStatuschk = false; this.IsDisablestatusChange = true;
    this.getWeeklyTimeSheetDetailsList();
    this.GetTimeSheetBillableDetailsList();
  }
  public temp_IsUserSelected : any; public temp_selectedUser : any; public temp_selectedUname : any;
  checksetMyStatesAsActive(strUserId, flag, name) {
    if (this.strlogtimedetail.length > 0) {
      this.temp_IsUserSelected = flag; this.temp_selectedUser = strUserId; this.temp_selectedUname = name;
      this.cancelbulkPublish('');
    } else {
      this.setMyStatesAsActive(strUserId, flag, name)
    }
  }
  onGetManagerAssignStaff() {
    this._timesheetService.GetManagerAssignStaff().pipe(takeUntil(this.unsubscribe)).subscribe((response: any) => {
      if (response) {
        this._lststaff = response;
        this.istimesheetStaffshow = (this._lststaff != undefined && this._lststaff.length > 0) ? true : false;

      }
    })
  }
  setMileStoneforJob(lstMilestonedata: any) {
    if (lstMilestonedata != undefined && lstMilestonedata != null && lstMilestonedata.length > 0) {
      const pcheck = lstMilestonedata.filter(u => u.status == true);
      if (pcheck.length > 0) {
        this._currentStatus = pcheck[0].statusName; this._currentjobStatusId = pcheck[0].statusId;
      } else { this._currentStatus = ''; this._currentjobStatusId = 0; } this.dynamicMilestone = this._currentStatus;
    }
  }
  getMileStoneList(jobId, selecteddate) {
    this._timesheetService.GetMileStoneByJobId(jobId).pipe(takeUntil(this.unsubscribe)).subscribe((response: any) => {
      if (response) {
        this.lstMilestonedata = response;
        this.setMileStoneforJob(this.lstMilestonedata);
      } this.getTimeSheetComment(jobId, 'JobId', selecteddate);
    })
  }
  deleteRow(index) {  
    if (this.dynamicArray.length == 0) {    //CUST-212, Sasmit , 13 June 2022
      this._toastr.error("Can't delete the row when there is only one row", 'Warning');
      return false;
    } else {
      this.tempdynamicArray = [];
      this.onDeleteChange(index);
      this.tempdynamicArray = this.dynamicArray;
      return true;
    }
  }
  addRowForGetResult(_lstWeekly) {
    this.dynamicArray = [];
    for (let i = 0; i < _lstWeekly.length; i++) {
      this.newDynamic = {
        contextId: _lstWeekly[i].contextId, context: _lstWeekly[i].context, name: _lstWeekly[i].name, day1: _lstWeekly[i].day1,
        day2: _lstWeekly[i].day2, day3: _lstWeekly[i].day3, day4: _lstWeekly[i].day4, day5: _lstWeekly[i].day5,
        day6: _lstWeekly[i].day6, day7: _lstWeekly[i].day7, dayTotal: _lstWeekly[i].dayTotal, isFinalInvoice: _lstWeekly[i].isFinalInvoice
        , cflagday1: _lstWeekly[i].cflagday1, cflagday2: _lstWeekly[i].cflagday2, cflagday3: _lstWeekly[i].cflagday3
        , cflagday4: _lstWeekly[i].cflagday4, cflagday5: _lstWeekly[i].cflagday5, cflagday6: _lstWeekly[i].cflagday6, cflagday7: _lstWeekly[i].cflagday7
      };
      this.dynamicArray.push(this.newDynamic);
    }
    return true;
  }

  addRow(index) {
    setTimeout(() => {
      this.scrollToElement();
    }, 100);
    
    localStorage.setItem("addtimesheetprof", "true");
    localStorage.setItem("addtimesheetnotify", "true");
    localStorage.setItem("addtimesheetindiv", "true");
    localStorage.setItem("addtimesheetchangepw", "true");
    this.newDynamic = { contextId: 0, context: "", name: "", day1: "", day2: "", day3: "", day4: "", day5: "", day6: "", day7: "", dayTotal: "00:00" };
    const checkEmpty = this.dynamicArray.filter(checkEmpty => checkEmpty.contextId==0 && checkEmpty.day1 == "" && checkEmpty.day2 == "" && checkEmpty.day3 == "" && checkEmpty.day4 == "" && checkEmpty.day5 == "" && checkEmpty.day6 == "" && checkEmpty.day7 == "");
    if (checkEmpty.length == 0) {
      this.dynamicArray.push(this.newDynamic);
    }   
    setTimeout(() => {
      this.getTimeSheetDetailsList();
    }, 1000);
    return true;
  }
  cancelHideButtons() {
    this.addcommentbuttonshow = false;
  }
  onShown($event) {
    //writecode here
  }
  onChanges($event) {
    this.searchdata();
  }
  public _tempOnchangeEvent: any;
  onChangesCheck($event) {
    if (this.strlogtimedetail.length > 0) {
      this._tempOnchangeEvent = $event;
      this.checkChangeWeekcancel();
    }
    else {
      this.onChanges($event);
    }
  }
  onOpenCalendar(container) { /*Developer: Ramya; Ticket: 1205; Date:27-May-2022*/

    container.monthSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(event.date));
    };
    container.yearSelectHandler = (event: any): void => {
      container._store.dispatch(container._actions.select(event.date));
    };

  }
  onClearAll() {
    this._tempindex = 0; this.onClearComment(); this.captureTime = new CaptureTime();
  }
  IsMonDayisGreater: any = false; IsTueDayisGreater: any = false; IsWedDayisGreater: any = false;   
  IsThursDayisGreater: any = false; IsFriDayisGreater: any = false; IsSatDayisGreater: any = false; IsSunDayisGreater: any = false;  // Devloper: Sachin yadav; Date: 16-05-2022;  Ticket: CUST-1170
  futureMonMsg: any;
  futureTueMsg: any;
  futureWedMsg: any;
  futureThuMsg: any;
  futureFriMsg: any;
  futureSatMsg: any;
  futureSunMsg: any;
  futureMsg: any;
  addcssheaderDay1: any;
  addcssheaderDay2: any;
  addcssheaderDay3: any;
  addcssheaderDay4: any;
  addcssheaderDay5: any;
  twoDaysAhead: any;
  twoDaysAheada: any;
  searchdata() {
    this.IsselectStatuschk = false;
    this._tempindex = 0;
    this.dynamicMilestone = '';
    this._currentStatus = '';

    const latestDate = this.datepipe.transform(this.model.startdate, 'yyyy,M,d');
    let dt = new Date(latestDate as string);

    // Helpers
    const startOfWeek = (date: Date): Date => {
      const diff = date.getDate() - date.getDay() + (date.getDay() === 0 ? -6 : 1);
      return new Date(date.setDate(diff));
    };

    const endOfWeek = (date: Date): Date => {
      const lastDay = date.getDate() - (date.getDay() - 1) + 6;
      return new Date(date.setDate(lastDay));
    };

    const addDays = (date: Date, days: number): Date => {
      const copy = new Date(date);
      copy.setDate(copy.getDate() + days);
      return copy;
    };

    this.timeCapturedforCell = false;
    this.fromdate = this.datepipe.transform(startOfWeek(dt), 'yyyy-MM-d');
    this.todate = this.datepipe.transform(endOfWeek(dt), 'yyyy-MM-d');
    this.GetTimeSheetBillableDetailsList();
    this.getWeeklyTimeSheetDetailsList();

    const startDate = startOfWeek(dt);
    this.mon = this.datepipe.transform(startDate, 'EE MMM d');
    this.mon1 = startDate;
    this.selectedDate = this.mon;

    this.twoDaysAhead = addDays(startDate, 2);
    this.twoDaysAheada = addDays(startDate, 1);

    const twoDaysAhead1 = addDays(this.mon1, 3);
    const fourDaysAhead = addDays(this.mon1, 4);
    // CSS logic
    this.addcssheaderDay1 = this.headerDay1 > 7 ? 'btn-primary' : 'bg-danger';
    this.addcssheaderDay2 = this.headerDay2 < 7 ? 'bg-danger' : 'bg-danger';
    this.addcssheaderDay3 = this.headerDay3 < 7 ? 'bg-danger' : '';
    this.addcssheaderDay4 = this.headerDay4 < 7 ? 'bg-danger' : '';
    this.addcssheaderDay5 = this.headerDay5 < 7 ? 'bg-danger' : '';

    this.dateCustomClasses = [
      { date: this.mon1, classes: [this.addcssheaderDay1, this.addcssclass] },
      { date: this.twoDaysAhead, classes: [this.addcssheaderDay3] },
      { date: this.twoDaysAheada, classes: [this.addcssheaderDay2] },
      { date: twoDaysAhead1, classes: [this.addcssheaderDay4] },
      { date: fourDaysAhead, classes: [this.addcssheaderDay5] },
    ];

    // Future-day restrictions
    const today = new Date(this.datepipe.transform(new Date(), 'yyyy,M,d') as string);
    const checkFuture = (day: Date): boolean => new Date(this.datepipe.transform(day, 'yyyy,M,d') as string) > today;

    this.IsMonDayisGreater = checkFuture(startDate);
    this.IsTueDayisGreater = checkFuture(addDays(startDate, 1));
    this.IsWedDayisGreater = checkFuture(addDays(startDate, 2));
    this.IsThursDayisGreater = checkFuture(addDays(startDate, 3));
    this.IsFriDayisGreater = checkFuture(addDays(startDate, 4));
    this.IsSatDayisGreater = checkFuture(addDays(startDate, 5));
    this.IsSunDayisGreater = checkFuture(addDays(startDate, 6));

    this.futureMsg = "You cant enter time for a future date"; // Developer: Ramya;  Ticket: CUST-1335;  Date: 03-June-2022
    this.futureMonMsg = this.IsMonDayisGreater ? this.futureMsg : "";
    this.futureTueMsg = this.IsTueDayisGreater ? this.futureMsg : "";
    this.futureWedMsg = this.IsWedDayisGreater ? this.futureMsg : "";
    this.futureThuMsg = this.IsThursDayisGreater ? this.futureMsg : "";
    this.futureFriMsg = this.IsFriDayisGreater ? this.futureMsg : "";
    this.futureSatMsg = this.IsSatDayisGreater ? this.futureMsg : "";
    this.futureSunMsg = this.IsSunDayisGreater ? this.futureMsg : "";

    // Weekday display labels
    this.Tuesday = this.datepipe.transform(addDays(startDate, 1), 'EE MMM d');
    this.Wednedday = this.datepipe.transform(addDays(startDate, 2), 'EE MMM d');
    this.Thruds = this.datepipe.transform(addDays(startDate, 3), 'EE MMM d');
    this.Friday = this.datepipe.transform(addDays(startDate, 4), 'EE MMM d');
    this.Sat = this.datepipe.transform(addDays(startDate, 5), 'EE MMM d');
    this.Sun = this.datepipe.transform(endOfWeek(dt), 'EE MMM d');

    this.displayMon = this.datepipe.transform(startDate, 'EE d');
    this.displayTue = this.datepipe.transform(addDays(startDate, 1), 'EE d');
    this.displayWed = this.datepipe.transform(addDays(startDate, 2), 'EE d');
    this.displayThr = this.datepipe.transform(addDays(startDate, 3), 'EE d');
    this.displayFri = this.datepipe.transform(addDays(startDate, 4), 'EE d');
    this.displaySat = this.datepipe.transform(addDays(startDate, 5), 'EE d');
    this.displaySun = this.datepipe.transform(endOfWeek(dt), 'EE d');

    this.w1 = startDate;
    this.w2 = addDays(startDate, 1);
    this.w3 = addDays(startDate, 2);
    this.w4 = addDays(startDate, 3);
    this.w5 = addDays(startDate, 4);
    this.w6 = addDays(startDate, 5);
    this.w7 = endOfWeek(dt);

    // Next/previous weeks
    const nextStartDate = new Date(startDate.getTime() + (7 * 24 * 60 * 60 * 1000));
    const nextEndDate = new Date(this.w7.getTime() + (7 * 24 * 60 * 60 * 1000));
    this.netmon = this.datepipe.transform(nextStartDate, 'EE MMM d');
    this.nextsun = this.datepipe.transform(nextEndDate, 'EE MMM d');

    const prevStartDate = new Date(startDate.getTime() - (7 * 24 * 60 * 60 * 1000));
    const prevEndDate = new Date(this.w7.getTime() - (7 * 24 * 60 * 60 * 1000));
    this.premon = this.datepipe.transform(prevStartDate, 'EE MMM d');
    this.presun = this.datepipe.transform(prevEndDate, 'EE MMM d');

    this.onClearAll();
  }

  nextdate() {
    this.onClearAll();
    this.count = 7;

    const addDays = (date: Date, days: number): Date => {
      const copy = new Date(date);
      copy.setDate(copy.getDate() + days);
      return copy;
    };

    const Nextstartdate = addDays(this.w1, this.count);
    const Nextenddate = addDays(this.w7, this.count);

    this.checkdates(Nextstartdate, Nextenddate);

    const Nexttuesdate = addDays(this.w2, this.count);
    const Nextweddate = addDays(this.w3, this.count);
    const Nextthrusdate = addDays(this.w4, this.count);
    const Nextfridate = addDays(this.w5, this.count);
    const Nextsatdate = addDays(this.w6, this.count);

    // Week labels
    this.netmon = this.datepipe.transform(Nextstartdate, 'EE MMM d');
    this.nextsun = this.datepipe.transform(Nextenddate, 'EE MMM d');
    this.nexttues = this.datepipe.transform(Nexttuesdate, 'EE MMM d');
    this.nextwed = this.datepipe.transform(Nextweddate, 'EE MMM d');
    this.nextthrus = this.datepipe.transform(Nextthrusdate, 'EE MMM d');
    this.nextfri = this.datepipe.transform(Nextfridate, 'EE MMM d');
    this.nextsat = this.datepipe.transform(Nextsatdate, 'EE MMM d');

    // Display labels
    this.displayMon = this.datepipe.transform(Nextstartdate, 'EE d');
    this.displayTue = this.datepipe.transform(Nexttuesdate, 'EE d');
    this.displayWed = this.datepipe.transform(Nextweddate, 'EE d');
    this.displayThr = this.datepipe.transform(Nextthrusdate, 'EE d');
    this.displayFri = this.datepipe.transform(Nextfridate, 'EE d');
    this.displaySat = this.datepipe.transform(Nextsatdate, 'EE d');
    this.displaySun = this.datepipe.transform(Nextenddate, 'EE d');

    // Sync with model
    this.mon = this.netmon;
    this.Sun = this.nextsun;
    this.Tuesday = this.nexttues;
    this.Wednedday = this.nextwed;
    this.Thruds = this.nextthrus;
    this.Friday = this.nextfri;
    this.Sat = this.nextsat;
    this.model.startdate = Nextstartdate;
    this.searchdata();
    this.mon1 = Nextstartdate;

    // Future dates for header coloring
    const twoDaysAhead = addDays(this.mon1, 2);
    const twoDaysAheada = addDays(this.mon1, 1);
    const twoDaysAhead1 = addDays(this.mon1, 3);
    const fourDaysAhead = addDays(this.mon1, 4);
    const fourDaysAhead1 = addDays(this.mon1, 5);
    const fourDaysAhead2 = addDays(this.mon1, 6);

    // Example static values (you can keep dynamic logic if needed)
    this.headerDay1 = 8;
    this.headerDay2 = 9;
    this.headerDay3 = 4;
    this.headerDay4 = 9;
    this.headerDay5 = 3;

    // CSS assignment helper
    const cssForDay = (val: number, threshold = 7, trueClass = '', falseClass = 'bg-danger') =>
      val < threshold ? falseClass : trueClass;

    this.addcssheaderDay1 = this.headerDay1 > 7 ? 'btn-primary' : 'bg-danger';
    this.addcssheaderDay2 = cssForDay(this.headerDay2);
    this.addcssheaderDay3 = cssForDay(this.headerDay3);
    this.addcssheaderDay4 = cssForDay(this.headerDay4);
    this.addcssheaderDay5 = cssForDay(this.headerDay5);

    this.dateCustomClasses = [
      { date: this.mon1, classes: [this.addcssheaderDay1, this.addcssclass] },
      { date: twoDaysAhead, classes: [this.addcssheaderDay3] },
      { date: twoDaysAheada, classes: [this.addcssheaderDay2] },
      { date: twoDaysAhead1, classes: [this.addcssheaderDay4] },
      { date: fourDaysAhead, classes: [this.addcssheaderDay5] },
    ];
  }

  prevousdate() {
    this.onClearAll();
    this.count = 7;
    const previousstartdate = new Date(this.w1.getTime() - (this.count * 24 * 60 * 60 * 1000));
    const previousenddate = new Date(this.w7.getTime() - (this.count * 24 * 60 * 60 * 1000));
    this.checkdates(previousstartdate, previousenddate);
    const pretuesddate = new Date(this.w2.getTime() - (this.count * 24 * 60 * 60 * 1000));
    const prewesdate = new Date(this.w3.getTime() - (this.count * 24 * 60 * 60 * 1000));
    const prethrudate = new Date(this.w4.getTime() - (this.count * 24 * 60 * 60 * 1000));
    const prefridate = new Date(this.w5.getTime() - (this.count * 24 * 60 * 60 * 1000));
    const presatdate = new Date(this.w6.getTime() - (this.count * 24 * 60 * 60 * 1000));
    this.premon = this.datepipe.transform(previousstartdate, 'EE MMM d');
    this.presun = this.datepipe.transform(previousenddate, 'EE MMM d');
    this.pretues = this.datepipe.transform(pretuesddate, 'EE MMM d');
    this.prewed = this.datepipe.transform(prewesdate, 'EE MMM d');
    this.prethrus = this.datepipe.transform(prethrudate, 'EE MMM d');
    this.prefri = this.datepipe.transform(prefridate, 'EE MMM d');
    this.presat = this.datepipe.transform(presatdate, 'EE MMM d');

    this.mon = this.premon;
    this.Sun = this.presun
    this.Tuesday = this.pretues;
    this.Wednedday = this.prewed;
    this.Thruds = this.prethrus
    this.Friday = this.prefri;
    this.Sat = this.presat;
    this.model.startdate = previousstartdate;
    this.searchdata();
    
    this.mon1 = previousstartdate;
    this.selectedDate = this.mon;
    const twoDaysAhead = new Date();
    twoDaysAhead.setDate(this.mon1.getDate() + 2);
    const twoDaysAheada = new Date();

    twoDaysAheada.setDate(this.mon1.getDate() + 1);
    const twoDaysAhead1 = new Date();
    twoDaysAhead1.setDate(this.mon1.getDate() + 3);
    const fourDaysAhead = new Date();
    fourDaysAhead.setDate(this.mon1.getDate() + 4);

    const fourDaysAhead1 = new Date();
    fourDaysAhead1.setDate(this.mon1.getDate() + 5);
    const fourDaysAhead2 = new Date();
    fourDaysAhead2.setDate(this.mon1.getDate() + 6);

    this.headerDay1 = 8;
    this.headerDay2 = 9
    this.headerDay3 = 4
    this.headerDay4 = 9
    this.headerDay5 = 3
    if (this.headerDay1 > 7) {
      this.addcssheaderDay1 = 'btn-primary';

    }
    else {

      this.addcssheaderDay1 = 'bg-danger';
    }

    if (this.headerDay2 < 7) {
      this.addcssheaderDay2 = 'bg-danger';
    }
    else {
      this.addcssheaderDay2 = '';
    }
    if (this.headerDay3 < 7) {
      this.addcssheaderDay3 = 'bg-danger';
    }
    else {
      this.addcssheaderDay3 = '';
    }

    if (this.headerDay4 < 7) {

      this.addcssheaderDay4 = 'bg-danger';
    }
    else {

      this.addcssheaderDay4 = '';
    }
    if (this.headerDay5 < 7) {

      this.addcssheaderDay5 = 'bg-danger';
    }
    else {

      this.addcssheaderDay5 = '';
    }

    this.dateCustomClasses = [
      { date: this.mon1, classes: [this.addcssheaderDay1, this.addcssclass] },
      { date: twoDaysAhead, classes: [this.addcssheaderDay3, ''] },
      { date: twoDaysAheada, classes: [this.addcssheaderDay2, ''] },
      { date: twoDaysAhead1, classes: [this.addcssheaderDay4, ''] },
      { date: fourDaysAhead, classes: [this.addcssheaderDay5, ''] },

    ];

  }


  GetLogCommentDetails(Id: any) {
    if (Id != 0) {
      this._timesheetService.GetLogCommentDetails(Id).pipe(takeUntil(this.unsubscribe)).subscribe((response: any) => {
        if (response) {
          this.fromdate = response.weekStart_At;
          this.todate = response.weekEnd_At;
          const sdate = this.datepipe.transform(response.commentDate, 'dd/MM/yyyy');
          if (response.contextId != 0) {
            this.getTimeSheetCommentByContext(response.contextId, response.context, sdate);
            this.logtimeService.GetAllCommentForContext(response.contextId, response.context, sdate).pipe(takeUntil(this.unsubscribe)).subscribe((response: any) => {
              if (response) {
                this.commentlst = response;
              }
            });
          }
        }
      });
    }
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();

    this.sub.unsubscribe();
  }

}

interface ICity {
  item_id: number;
  item_text: string;
  item_di: boolean;
}
export interface User {
  name: string;
  value: string;
}
